export default {
  languageType: "en",
  lang: "en",
  welcome: "WELCOME",
  select_your_language: "Select your language",
  phone_number_placeholder: "Mobile Number",
  whats_your_phone_number: "What's your mobile number?",
  enter_mobile_number: "Enter your number",
  we_will_send_you_verification_code: "We will send you a verification code",
  we_have_sent_a_verification_code_to: "We have sent a verification code to",
  no_internet_please_login_again: "No internet, please login again",
  timeout_message:
    "There's a problem in restoring your data, please log in again",
  enter_your_verification_code: "Enter Your Verification Code",
  verification_code: "VERIFICATION CODE",
  view_report: "View report",
  business_updated_success: "Business Updated successfully",
  coming_soon: "Coming soon",

  i_didnt_get_a_code: "I didn't get a code",
  resend_code_in: "Resend code in",
  having_trouble: "Having trouble?",
  call_us: "Call us at",
  invalid_code: "Invalid Code",
  search_customers_by_name_or_phone_placeholder:
    "Search by name or phone number",
  add_customer_details: "Add Customer Details",
  customer_name: "Customer name",
  enter_mobile_number_optional: "Enter Mobile Number (Optional)",
  mobile_number_optional: "Enter Mobile Number (Optional)",
  phone_number: "Phone number",
  mobile_number: "Mobile number",
  watch_video: "Watch video",

  create_customer_to: "Create customer to",
  to_give_udhaar: "give udhaar",
  create_customer: "Create Customer",
  how_to_add_a_new_customer: "How to add a new customer?",
  learn_how_to_use_oscar_udhaar: "Learn how to use oscar udhaar",

  save_and_exit: "Save & Exit",

  udhaar: "udhaar",
  accept_payment: "Accept Payment",
  give_udhaar: "Give Udhaar",
  total: "Total",
  select_date: "Select date ",
  udhaar_note: "Add Note or Item (Optional)",

  balance: "Balance",
  balance_amount: "Balance",

  login: "Login",
  get_started: "Get Started",
  lets_get_started_for_free: "Let's Get Started for Free",
  purany_reg_ko_choren: "Leave your old register behind",
  ab_saara_hisaab_phone_pei: "Now keep all your accounts on your phone",

  enter_phone_placeholder: "Enter Phone #",
  dont_have_account: "Don't have an account? Create New Account",

  // Give UDHAAR
  please_enter_correct_amount: "please enter correct amount",
  give: "Give",
  UDHAAR: "UDHAAR",
  accept: "ACCEPT",
  PAYMENT: "PAYMENT",
  add_payment: "Add Payment",

  advance: "Advance",

  net_udhaar: "Net Udhaar",
  net_advance: "Net Advance",
  udhaar_due: "Udhaar Due",
  advance_payment: "Advance payment",

  total_udhaar_given: "Total Udhaar Given",
  total_advance: "Total Payment",
  total_udhaar: "Total Udhaar",
  share_oscar_udhaar_with: "Share Oscar Udhaar with your friends and family",
  are_you_sure_you_want_to_delete_image:
    "Are you sure you want to delete image?",
  are_you_sure_you_want_to_exit: "Are you sure you want to exit?",

  //credithistory screen
  date_and_time: `Date & time`,
  udhaar_book: "Udhaar book",
  udhaars: "Udhaars",
  payment: "Payment",
  payments: "Payments",
  balance_amount_credit_screen: "Balance",
  sms: "SMS",
  reminder: "REMINDER",
  please_install_watsapp: "Please Install Whatsapp",

  //todaykhata screen
  as_of_today: "AS OF TODAY",
  total_customer: "Customers",
  net_balance: "Net Balance",

  //sharing screen
  share_on_whatsapp: "Share on WhatsApp",
  more_options: "MORE OPTIONS",
  thankyou: "Thank you!",

  //Drawer Component
  home: "Home",
  language: "Language",
  logout: "Logout",
  log_out: "Log out",
  urdu: "Urdu",
  english: "English",
  business: "Business",

  profile: "Profile",
  settings: "Settings",
  business_card: "Business Card",

  //filter options text
  sort_by_atoz: "Sort by A-Z",
  sort_by_ztoa: "Sort by Z-A",
  balance_due: "Balance due",

  //note modal
  note: "Note",

  promotions: "Promotions",
  promotions_are_not_available_at_the_moment:
    "Oops! It seems there's no promotion available at the moment",
  customers_not_found: "No Results for Customer",
  next: "Next",
  are_you_sure_you_want_to_logout: "Are you sure you want to logout?",
  internet_is_required_for_sign_in: "Internet is required for Sign in",
  internet_is_required_for_sign_up: "Internet is required",
  add_your_first_entry: "Add your first entry",
  mobile_no_is_already_registered: "Phone # is already registered",
  customer_updated_successfully: "Customer updated successfully",
  transaction_updated_successfully: "Transaction successfully updated",
  transaction_added_successfully: "Transaction successfully added",
  no_customer_found_by_name: "No customer found by this name",
  woulud_you_like: "Would you like to add",
  add_user: "Add Customer",
  added_on: "Added on",
  user_not_found_create_an_account: "User not found. Create an account",
  verification_code_has_been_sent: "Verification code has been sent",
  this_number_associate_with_another_customer:
    "This number associate with another customer",
  no_customer_found: "No customer found, Add ",

  //edit profile
  business_name: "Business name",
  business_name_label: "Business name",
  business_name_placeholder: "Enter business name",
  update: "Update",
  business_name_cannot_be_empty: "Name can not be empty",
  free_sms_bheje: "Enter Customer Phone # to send Free SMS",
  update_customer: "Edit Customer",
  business_category_is_required: "Business category is required",
  business_category_label: "Business category",

  //view_customer_profile
  customerprofileheading: "Customer Profile",
  do_you_want_to_delete: "Do you want to delete customer?",
  yes: "Yes",
  cancel: "Cancel",
  no: "No",
  delete_customer: "Delete Customer",
  delete_supplier: "Delete supplier",
  customer_number: "MOBILE NUMBER",
  transaction_sms: "Transaction SMS",

  //creatcustomer screen
  create_customertitle: "Create Customer",

  //Account Statment Screen
  advance_acc: "Advance",
  due_acc: "Due",
  customer: "Customer",
  transactions: "Transactions",
  transactions_type: "Transactions type",
  account: "Account",
  account_statement: "Account statement",
  transaction_statement: "Transaction statement",
  manage_your_ledger:
    "Manage your ledger with the Udhaar app to save time and increase collection by 3x",
  date_select: "Select Date",
  today: "Today",
  yesterday: "Yesterday",
  last_seven_days: "Last 7 Days",
  last_thirty_days: "Last 30 Days",
  date_acc: "Date",
  filter_options: [
    "Today",
    "Yesterday",
    "Last 7 Days",
    "Last 30 Days",
    "Last Month",
    "All Time",
    "Cancel",
  ],

  //Edit Transactions Screen
  udhaar_amount: "Udhaar Amount",
  advance_amount: "Advance Amount",
  payment_amount: "Payment Amount",
  edit_transaction: "Edit Transaction",
  enter_amount_trans: "Enter amount",
  add_note_trans: "Enter Note or Item",
  do_you_want_to_delete_transaction: "Do you want to delete transaction?",
  customer_will_receive_SMS:
    " Customer will receive SMS with edited information",
  delete_transaction: " Delete Transaction",
  transaction_deleted: "Transaction deleted successfully",
  save: "Save",

  //backup screen
  backup: "Backup",
  oscar_udhaar_backs_up_your_data_twice_a_day_automatically:
    "Udhaar app automatically backs up your data, so your data is 100% safe & secure.",

  in_case_app:
    "In case the app is deleted, simply download Oscar Udhaar again and login using your mobile number All your data will be automatically restored.",
  easy_safe_reliable: "Easy, safe, Reliable",
  last_backup_time: "Last backup time",
  backup_successful: "Backup Successful",
  backup_now: "Backup Now",
  backup_not_successful: "Backup not successful. Try again.",
  data_not_backup: "You data is not fully backed up. Please backup your data.",
  uploading_your_backup_please_wait: "Backing up your data",
  restoring_your_backup_please_wait: "Restoring your data",
  uploading: "uploading",
  restoring: "restoring",

  // customer list
  name_can_not_be_empty: "Name can not be empty",
  contact_list: "Contact List",
  add_new_customer: "Add New Customer",
  contacts: "Contacts",

  // Business Card
  business_category: "Business Category",
  address: "ADDRESS",
  enter_address_optional: "Enter Address",
  other_info: "OTHER INFO",
  ohter_info_placeholder: "Email, About, Name",
  email: "EMAIL",
  email_placeholder_optional: "Enter Email",
  about_us: "ABOUT US",
  about_us_placeholder_optional: "Enter About Us",
  contact_name: "Contact name",
  contact_name_placeholder_optional: "Enter Contact Name",
  create_and_share_business_card: "Create and share your business card",
  business_name_is_required: "Business Name is Required",
  share_business_card: "SHARE BUSINESS CARD",
  phone_number_is_required: "Mobile Number is Required",
  address_is_required: "Address is Required",
  email_is_required: "Email is Required",
  about_us_is_required: "About Us is Required",
  contact_name_is_required: "Contact Name is Required",
  other_info_is_required: "Please complete the required fields",
  email_business_card: "Email :",
  address_business_card: "Address :",
  more_options_business_card: "More Options",

  add_business_name: "Add Business Name",
  number_of_customers: "# of Customers",
  download: "Download",
  select_mobile_network_placeholder: "(For ported number, to receive OTP)",
  select_mobile_network_placeholder2:
    "For ported number, select correct network",
  mobile_network: "Mobile network",
  phone_number_format: "Mobile number should be in format e.g. 03001234567",
  phone_number_length: "Mobile number should be 11 digits (e.g. 03xx1234567)",
  network_required: "Mobile Network is Required",
  telenor: "Telenor",
  jazz: "Jazz",
  ufone: "Ufone",
  zong: "Zong",
  scom: "Scom",
  select_business_category: "Select business category",
  camera: "Camera",
  gallery: "Gallery",
  delete: "Delete",
  photo_added: "Photo Added",
  please_select_your_business_category: "Please select your business category",
  upload_from: "Upload From",
  take_photo: "Take Photo",
  with_camera: "With Camera",
  internet_connection_is_required: "Internet Connection is Required",
  no_internet: "No internet",
  internet_to_view_image: "Internet Connection is Required to View the Image",
  internet_to_upload_image:
    "Internet Connection is Required to Upload the Image",
  udhaar_balance: "Udhaar Balance",
  advance_balance: "Advance Balance",
  ledger_secured: "Ledger Secured & Validated",
  friends_at_udhaar: "- your friends at Udhaar",
  transaction_saved: "Transaction Saved",
  message_sent: "Message has been sent",
  payment_reminder: "Payment Reminder",
  eid_card: "Eid Card",
  send_eid_card: "Send Eid Card",
  share_eid_card: "Share Eid Card",
  create_share_eid_card: "Create and Share your Eid Card",
  greeting_salutation: "GREETING / SALUTATION",
  greeting_placeholder: "Enter Greeting",
  greeting_required: "Greeting is required",
  eid_message: "EID MESSAGE",
  eid_message_placeholder: "Enter Eid Message",
  message_required: "Eid Message is required",
  signature: "Signature",
  signature_placeholder: "Enter Signature",
  signature_required: "Signature is required",
  send_card_to_customers: "Send free Eid card to your customers",
  greeting_message_requried: "Greeting and Message is required",
  set_collection_date: "Set Collection Date",
  collection_date: "Collection Date",
  select_collection_date: "Select Collection Date",
  collection_sub_heading: "SMS reminder will be sent to your customer on ",
  collection_sub_heading_2:
    "SMS reminder will be sent to your customer on selected date",
  clear: "Clear",
  collection_due: "Collection Due",
  sms_will_be_sent: "Automatic SMS alert will be sent",
  remind: "Remind",
  collection: "Collection",
  payment_due_today: "Payment is Due Today",
  past_due: "Past due",
  five_days: "5 Days",
  ten_days: "10 Days",
  fifteen_days: "15 Days",
  next_month: "Next Month",
  request_payment: "Request Payment",
  send_via_whatsapp: "Send via Whatsapp",
  send_via_sms: "Send via SMS",
  call_customer: "Call Customer",
  independence_day_tag: "Share your Aug 14 video to win Rs 2,000",
  independence_day_video: "Independence Day Video",
  create_share_independence_video:
    "Create and Share your Independence Day Video",
  share_facebook: "Share on Facebook",
  please_install_facebook: "Please Install Facebook",
  request_dues: "Request Dues",
  restore_error: "Your data restore was interrupted, please login again",
  record_video_message: "Record A Video Message",
  record_video: "Record Video",
  video_message_1: "Record an Independence Day",
  video_message_2: "message for your friends",
  video_sub_message: "Make a 20-40 sec video and win Rs 2,000",
  follow_these_steps: "Follow these steps",
  step_1: "Share the video on your timeline",
  step_2: "Add #tags #AzadiStar #UdhaarApp #Azadi2020",
  step_3: "Get your friends to share it",
  step_4: "The most shared video wins the Rs 2,000 Azadi prize",
  step_5: "Share your post in the comments",
  download_report: "Download Report",
  send_free_sms: "Send Free SMS to ",
  aap_ne: "You have",
  liye_hain: "taken",
  info: "Info",
  send_sms: "SEND SMS",
  sedf_sms2: "Send SMS",
  not_now: "NOT NOW",
  quotes: [
    "Tough is your middle name",
    "Let's get it done",
    "Nothing you can't handle",
    "You can do it and you know it",
    "Flex your 'can do' muscle",
    "Impress yourself today",
    "Seize the day",
    "Buckle down and push forth!",
    "Don't try harder. Do harder!",
    "March forward!",
    "Keep your chin up",
  ],

  trusted_by: "Trusted by 5.1M+ businesses across Pakistan",
  trusted_b: "Trusted by over 5.1M+ businesses",
  by_continuing: "By continuing you agree to our",
  terms_of_services: "Terms of Services",
  privacy_policy: "Privacy Policy",
  other_category: "OTHER CATEGORY",
  enter_other_category: "Enter Other Category",
  add_customer: "Add customer",
  send_via: "Send via",
  whatsapp: "Whatsapp",
  report: "Report",
  customer_statement: "Customer",
  ledger_ready: "Your ledger is ready",
  have_a_wonderful_day: "Have a wonderful day",
  having_trouble_contact_us: "Having Trouble? Contact us",
  loading_your_data: "Loading your data from cloud backup",
  data_loaded: "Data loaded. Preparing Ledger",
  awsome_phone_verified: "Awesome. Your phone # is verified.",
  businesss_will_be_displayed:
    "You can send Free SMS to your customers with your Business Name.",
  logged_in_from_another_device: "Session Expired.",
  device_has_been_logged_out:
    'Your session has expired. Click "Use here" to use Udhaar app.',
  use_here: "Use Here",
  grow_business_with_udhaar: "Grow your business with Udhaar app",
  enter_khata_amount: "Enter Khata amount",
  share_details_with_sms: "Share details with free SMS",
  play_and_win_cash: " Play quiz & win cash prize.",
  play_now: "Play now",
  udhaar_quiz: "Udhaar Quiz",
  play_and_earn_gifts: "Play & earn amazing gifts",
  how_to_play: "Play & win Rs 1000",
  trivia_instructons_1: "Answer all questions correctly",
  trivia_instructons_2: "Quiz time is 60 seconds",
  trivia_instructons_3: "Win Rs 1000 every week",
  start_quiz: "Start Quiz",
  quiz_timings: "Quiz timings 12PM - 4PM Everyday",
  help: "Help",
  question: "Question",
  congrats_you_won: "Congratulations! You won",
  sorry_you_didnt_win: "Sorry, you didn't win",
  missed_by_1: "Oops, missed by just 1",
  lucky_draw_will_be_announced:
    "Lucky draw winner will be announced on Friday at 4PM",
  share_on_facebook_to_win:
    "Share on Facebook to increase your chances of winning.",
  IA_next_time: "Better luck on the next round tomorrow.",
  new_quiz_tomorrow: "Next quiz starts tomorrow",
  share: "Share",
  back_to_home: "Back to home",
  contact_us: "Contact us",
  terms_and_conditions: "Terms and conditions",
  trivia_term_1: "1. This quiz is organised by Oscar",
  trivia_term_2:
    "2. All participants entering the quiz must follow these terms and conditions",
  trivia_term_3: "3. There are no charges to enter the quiz",
  trivia_term_4: "4. The quiz can be played from 12 noon to 4 pm",
  trivia_term_5:
    "5. Entries that do not comply with the terms and conditions will not be accepted",
  trivia_term_6: "6. Incomplete or improper entries will also not be accepted",
  trivia_term_7:
    "7. A new quiz round will start every Friday and end on Thursday",
  trivia_term_8: "8. Winners will be announced weekly on Friday",
  trivia_term_9:
    "9. Everyone registered on the Udhaar app can take part in the quiz",
  quiz_submit_karnai_ke_baad: "After submitting the quiz:",
  after_submit_1: "1. The winning participant's prize is Rs 1000",
  after_submit_2:
    "2. Answering 3 questions daily counts as 1 entry. Only participants who answer all 3 questions correctly will enter the second round (lucky draw)",
  after_submit_3:
    "3. The more correct entries in a week, the higher the chances of winning",
  after_submit_4: "\"4. Once the winner is decided, before the announcement, the participant will share these details:\n        a. Name\n        b. Contact #\n        c. Postal Address\n        d. NIC #\n        e. Photograph (Optional)",
  after_submit_5:
    "5. The prize will be delivered within 3-4 working days after the winner announcement",
  after_submit_6:
    "6. In case of any uncertainty or dispute, Oscar's decision will be final and will not be open to discussion",
  after_submit_7:
    "7. Oscar may cancel or postpone the quiz for any reason. Prize money may also be changed. Oscar is not obliged to give notice of these changes",
  after_submit_8:
    "8. Oscar reserves the right to cancel the prize money if it is being used for any unethical or illegal activity",
  after_submit_9:
    "9. By entering the quiz, you agree that if you win, your name and city will be shared on Udhaar's social channels",
  after_submit_10:
    "10. Oscar reserves the right to change the terms and conditions without prior notice",
  do_you_want_to_exit: "Do you really want to exit?",
  you_wont_be_able_to_play:
    "You won’t be able to play again today. Next quiz starts tomorrow.",
  data_not_backedup: "Data not backed up.",
  click_here: "Click here",
  to_backup_your_data: "to back up data.",
  backup_success: "Data backup successful",
  select_account_statement_filter: "Select Account Statement Filter",
  selected_filter: "Selected Filter: ",
  custom: "Custom",
  select_upcoming_date: "Select an upcoming date",
  filter_error: "Filter Error",
  dont_know: "Don't know",
  filter: "Filter",
  no_contact_permission_1:
    "Would you like to select contacts from your phone book.",
  no_contact_permission_2:
    "Give Udhaar app permission to access your contacts.",
  no_contact_permission_3: "Click Here to give permission.",
  collection_date_heading: "COLLECTION DATE",
  pending: "Pending",
  upcoming: "Upcoming",
  settled: "Settled",
  sort_by: "SORT BY",
  filter_name_az: "Name (A-Z)",
  filter_amount: "Amount",
  filter_amount_desc: "Amount Descending",
  filter_least_recent: "Least Recent",
  filter_most_recent: "Most Recent",
  filter_due_date: "Due Date",
  transaction_type: "Transaction type",
  default: "Default",
  apply: "Apply",
  all: "All",
  loading_your_contacts: "Loading your contacts.",

  enter_pin_to_use_udhaar: "Enter PIN to use Udhaar app",
  enter_pin_to_remove_pin: "Enter PIN to remove security",
  set_new_udhaar_app_pin: "Set new Udhaar app PIN",
  pin_did_not_match: "PIN code did not match",
  pin_lock_has_been_removed: "PIN lock has been removed",
  confirm_udhaar_app_pin: "Confirm Udhaar app PIN",
  enter_pin: "Enter PIN",
  enter_pin_here: "Enter PIN here",
  udhaar_security: "Udhaar Security",
  touch_sensor: "Touch Sensor",
  you_must_set_a_pin_first: "You must set a PIN first",
  remove_biometric: "Remove biometrics",
  pincode: "PIN code",
  set_a_4_digit_pincode: "Set a 4-digit PIN code",
  enable: "Enable",
  face_id: "Face ID",
  touch_id: "Touch ID",
  biometrics: "Biometrics",
  app_lock: "App Lock",

  udhaar_app_secure_lock: "Udhaar App Secure Lock",
  please_use_fingerprint_to_unlock_app: "Please use Fingerprint to unlock app",
  show_finger: "Show finger",
  touch_the_fingerprint_sensor: "Touch the fingerprint sensor",

  wrong_pin: "Wrong PIN. You have",
  attempts_remaining: "attempts remaining",
  reset_pin: "Reset PIN",
  forgot_pin: "Forgot PIN?",
  your_udhaar_app_account_is_locked: "Your Udhaar App account is locked",
  tap_here_to_use_finger_print_login: "Tap here to use fingerprint login",

  commission_earned: "Commission Earned",
  customer_n: "Customer #",
  easyload: "Easyload",
  commission: "Commission",
  wallet: "Wallet",
  give_easy_load: "GIVE EASY LOAD",
  choose_network: "Choose Network",
  earned: "Earned",
  add_balance: "Add Balance",
  easy_load_by_udhaar: "Easy Load by Udhaar app",
  earn_commission_with_udhaar:
    "Earn up to 2.5% commission on EasyLoad with Udhaar app",
  easy_load_in_3_steps: "Easy Load in 3 easy steps",
  add_balance_to_wallet: "Add balance to Wallet",
  enter_customer_number: "Enter customer mobile number",
  give_easy_load_earn_commission: "Give Easylaod & earn commission",
  addBalance: "ADD BALANCE",
  add_money_to_wallet: "Add money to your wallet",
  easy_paisa: "Easy Paisa",
  jazz_cash: "Jazz Cash",
  ubl: "UBL",
  hbl: "HBL",
  easy_paisa_account: "Easypaisa Account",
  jazz_cash_account: "Jazz Cash Account",
  ubl_account: "UBL Account",
  hbl_account: "HBL Account",
  accounts: "Accounts",
  mobile_number_label: "Mobile Number",
  number_verification_note:
    "Note: OTP code will be sent to confirm mobile number",
  amount_required: "Amount is required",
  easypaisa_pin_confirmation: "Easypaisa Pin Confirmation",
  jazzcash_pin_confirmation: "Jazz Cash Pin Confirmation",
  ubl_pin_confirmation: "UBL Pin Confirmation",
  hbl_pin_confirmation: "HBL Pin Confirmation",
  pin_confirmation: "Pin Confirmation",
  enter_otp_code: "Enter OTP",
  submit: "Submit",
  has_been_added_to_wallet: "has been added to your wallet balance.",
  you_can_use_the_balance:
    "You can now use the balance for recharge and payments",
  edit_information: "Edit Information",
  earn_money: "Earn Money",
  b_card: "B.Card",
  play_quiz: "Play Quiz",
  easy_load: "Easy Load",
  prepaid: "Prepaid",
  postpaid: "Postpaid",
  device: "Device",
  no_packages_available: "No Packages Available",
  recharge_details: "Recharge Details",
  network: "Network",
  phone_number_small: "Mobile Number",
  feeAndTax: "Fee & Tax",
  no_charges: "No Charges",
  total_amount: "Total Amount",
  pay_now: "PAY NOW",
  easyload_successful: "Easyload Successful",
  phoneN: "Phone #:",
  sms_has_been_sent: "SMS has been sent to the number above",
  edit_share_whatsapp: "Edit and Share on WhatsApp",
  edit: "Edit",
  marketing_in_easy_steps: "Marketing in 3 easy steps",
  choose_your_details: "Choose your details",
  enter_your_details: "Enter your details",
  share_details_whatsapp: "Share details on Whatsapp",
  add_first_banner: "Add your first banner",
  offer: "50% OFF OFFER",
  best_quality_products: "Best quality products at reasonable price",
  shop_from: "Shop From",
  my_shop: "My Shop",
  enter_heading: "Enter Heading",
  enter_description: "Enter Description",
  description_placeholder: "Best quality products",
  enter_shope_name: "Enter Shop Name",
  share_store_banner: "Share Store Banner",
  edit_template: "Edit Template",
  invalid_amount: "Invalid Amount",

  get_more_business: "Get more business with Free Marketing",
  select_your_marketing_banner: "Select your marketing banner",
  add_promotion_or_other_special_message:
    "Add promotion or other special message",
  share_with_friends_and_customers: "Share with friends and customers",
  marketing: "Marketing",
  more: "More",
  new: "New",

  to_take: "To Take",
  to_give: "To Give",
  total_taken: "Total Taken",
  total_given: "Total Given",
  entry: "Entry",
  entries: "Entries",
  given: "Given",
  taken: "Taken",
  give_: "Give",
  take: "Take",

  your_business: "Your Business",
  create_new_business: "Create new business",
  switching_to_business: "Switching to {name}",
  add_new_business: "Add New Business",
  select_start_date: "Select Start Date",
  select_end_date: "Select End Date",

  transaction: "Transaction",
  add_your_first_traansaction: "Add your first transaction",
  setup_your_invoice_transaction_with_us:
    "Setup your invoice transaction with us",
  loading: "Loading",
  active_filter: "Active Filters",

  new_transaction: "New Transaction",
  buy: "Buy",
  sell: "Sell",
  add_details: "Add details",
  add_business: "ADD BUSINESS",
  logout_anyway: "LOGOUT ANYWAY",
  logout_backup: "BACKUP",
  waiting_otp: "Waiting to auto detect OTP code",
  enter_code: "Enter 4-digit code",
  call_me: "Call me",
  verify: "Verify",
  have_you_change_mobile_network: "Have you changed your phone network?",
  select_network_to_rec_otp: "Please select your new network to receive OTP",
  waiting_for_code: "Waiting for code",
  otp_call: "You will get a OTP code on call.",
  add_customer_and_maintain_udhaar:
    "Add customers and maintain your ledger. Free payment reminders. 3x faster collection.",
  manage_your_business:
    "Manage your khata & business. Send reminders, recieve payments. All free.",
  trusted_b_over: "Trusted by over 5.1M+ businesses",
  stat_using_udhaar_app: "START USING UDHAAR BOOK",
  dont_ask: "Don't ask again",
  manage_daily_cash_transactions: "Manage your daily cash, sales and expenses",
  invoice_descp_1: "Tally cash balance in hand vs sales & expenses",
  invoice_descp_2: "Create custom bills & invoices with item details",
  invoice_descp_3: "Download monthly & daily reports",
  cash_in: "Cash in",
  cash_out: "Cash out",
  add_item: "Add Item",
  change_date: "Change Date",
  add_photo: "Add Photo",
  add_note: "Add Note",
  select_invoice_date: "Select Invoice Date",
  reset: "Reset",
  enter_item_name: "Enter item name",
  enter_item_placeholder: "E.g Mango",
  item_name_required: "Item name is required",
  add_another_item: "Add Another Item",
  invalid_quantity: "Invalid Quantity",
  customer_list: "Customer List",
  select_invoice_status: "Select Invoice Status",
  paid: "Paid",
  not_paid: "Not Paid",
  select_payment_method: "Select Payment Method",
  cash: "Cash",
  bank: "Bank",
  add_your_own: "Add your own",
  payment_method: "Payment method",
  change_method: "Change Method",
  // add_your_own: 'Add your own',
  invoice: "Invoice",
  verified_by: "Verified by",
  item_details: "Item details",
  qty: "Qty",
  // total_amount: 'Total amount',
  made_with: "Made with ",
  in: "In",
  out: "Out",
  cash_out_amount: "Cash out amount",
  cash_in_amount: "Cash in amount",
  cash_in_placeholder: "Enter cash in amount",
  cash_out_placeholder: "Enter cash out amount",
  take_a_picture: "Take a photo",
  upload_from_gallery: "Upload from gallery",
  take_photo_with_camera: "Take photo with camera",
  more_items: "More Items",
  transaction_successful: "Transaction Successful",
  cash_on_hand: "Cash on hand",
  cashbook: "Cash Book",
  sales: "Sales",
  expense: "Expense",
  bill: "Bill",
  add_bill_to_contact: "Add bill to contact",
  automatically_add_credit_to_contact:
    "Do you want to automatically add credit to contact?",
  // no: 'No',
  quick_entry: "Quick Entry",
  itemized_entry: "Itemized Entry",
  // transaction_type: 'Transaction Type',
  invoice_can_be_edited_cashbook:
    "Invoices can only be edited / deleted from Cash Book",
  delete_associated_invoices: "Delete associated invoices",
  do_you_want_to_delete_invoice:
    "Do you want to `delete invoice`s associated to this contact?",
  // manage_your_business: 'Manage your khata & business. Send reminders, recieve payments. All free.',
  // trusted_b_over: 'Trusted by over 5.1M+ business',
  // stat_using_udhaar_app: 'START USING UDHAAR BOOK',
  todays_balance: "Today's Balance",
  delete_entry: "Delete Entry",
  credit_added_to_contact: "Credit has been added to this contact",
  contact_via_whatsapp: "Contact via Whatsapp",
  credit: "Credit",
  add_contact: "Add contact",
  share_your_promotions: "Share your promotions",
  edit_sales: "Edit Sales",
  edit_expense: "Edit Expense",
  play_tutorial: "See Video",
  see_help_tutorial: "See help tutorial",
  manage_cash_sale: "Manage your sales & expenses",
  send_free_invoices: "Send free bill & invoices to customers.",
  send_free_promotions: "Send free promotions",
  send_free_promotions_to_customer:
    "Send free promotions to customers and grow sales.",
  share_udhaar_app: "Share Udhaar app with your friends.",
  earn_upto: "Earn up to Rs. 45,000/month.",
  you_will_get:
    "You will get Rs. 20 for each friend that does 2 entries on 2 days",
  contact_customer: "Contact Customer",
  sell_online: "Sell Online",
  latest_transaction: "Most Recent",
  reminder1: "Reminder",
  collect_today: "Collect Today",
  pending_collection: "Pending Collection",
  collect_on: "Collect on",
  send_reminder: "Send Reminder",
  set_new_date: "Set New Date",
  active_filter2: "Active Filter",
  collection_set_successfully: "Collection date set successfully",
  total_earning: "Total Earning",
  not_earned_money: "Share with friends to earn now.",
  app_installed: "App installed",
  two_entries_done: "2 entries done",
  rs10_earned: "Rs 10 earned",
  add_phone_number: "Add Mobile Number",
  add_phone_to_set_date: "Add mobile number to set collection date",
  remind_with_whatsapp: "Remind with Whatsapp",
  remind_with_sms: "Remind with SMS",
  no_pending_collections: "Hurrah! No pending collections",
  no_collection_for_today:
    "No Collection for today, go to pending and set collection dates to collect money faster",
  remove_colletion_from_selected:
    "Remove collection dates from selected contacts?",
  collection_removed_successfully: "Collection date removed successfully",
  no_collection_today_line_1: "No Collections for today. Go to ",
  no_collection_today_line_2:
    "and set collection dates to collect money faster",
  no_collection_upcoming_line_1: "No Collections for upcoming. Go to ",
  turn_off_invoice_for_all:
    "Do you want to turn off automatic invoices for ALL future transactions?",
  billbook: "Bill Book",
  search_item: "Search item",
  items_list: "Items List",
  item_stock: "Item Stock",
  enter_item_stock: "Enter Item Stock",
  selling_price: "Selling Price",
  enter_selling_price: "Enter Selling Price",
  cost_price: "Cost price",
  enter_cost_price: "Enter Cost Price",
  add_price: "Add Price",
  edit_item: "Edit item",
  bill_details: "Bill Details",
  item: "Item",
  items: "Items",
  cash_added_to_contact: "Cash has been added to Cash Book",
  net_profit: "Net profit",
  all_time: "All Time",
  this_week: "This Week",
  this_month: "This Month",
  // bill: 'Bill',
  bill_can_be_edited_cashbook:
    "Bills can only be edited / deleted from Billbook",
  add_items: "Add Items",
  select_items: "Select Items",
  no_items_added_recently: "No items added recently",
  current_bill: "Current Bill",
  press_the_mark_to_add: "doesnt exist or is already selected",
  item_already_in_bill: "Item already added to bill",
  item_with_this_name_exists:
    "Item with this name already exists, please enter a new name",
  sales_amount: "Sale Amount",
  sales_amount_placeholder: "Enter sales amount",
  cost_amount: "Cost Amount",
  cost_amount_label: "Cost Amount (optional)",
  cost_amount_placeholder: "Enter cost amount",
  optional_information: "Optional Information",
  your_loss: "Your Loss",
  your_profit: "Your Profit",
  items_added: "Items Added",
  remove: "Remove",
  enter_note_terms: "Enter Note / Terms",
  select_payment_information_optional: "Select Payment Information (optional)",
  has_the_bill_paid: "Has the bill been paid?",
  select_bank: "Select bank",
  select_wallet: "Select Wallet",
  total_Entries: "Total 7 Entries",
  start_date: "Start Date",
  end_date: "End Date",
  save_items: "Save Items",
  add_an_item: "Add an Item",
  bill_items: "Bill Items",
  share_bill: "Share Bill",
  do_not_share_bill: "Do not share bill",
  // add_details: 'Add details',
  optional: "(optional)",
  going_back_will_discard_transaction:
    "Going back will discard your transaction",
  go_back: "Go back",
  cashbook_report: "Cashbook Report",
  profit: "Profit",
  total_sales: "Total sales",
  total_expense: "Total expense",
  select_report_type: "Select report type",
  download_pdf: "Download PDF",
  bill_pdf_processing: "Bill PDF is being prepared...",
  bill_pdf_unavailable: "Bill PDF is not available right now",
  detailed_report: "Detailed report with all entries",
  summary_report: "Day wise summary report",
  other_category_label: "Other category",
  recharge: "Recharge",
  connect_your_account: "Connect your account",
  earn_upto_3_commission: "Earn up to",
  // commission: 'commission',
  on_easy_load: "on EasyLoad",
  add_balance_for_easyload: "Add Balance for EasyLoad",
  invoice_book: "Invoice Book",
  purchase_invoice: "Purchase Invoice",
  purchase_bill: "Purchase bill",
  purchase_report: "Purchase report",
  now_you_can_collect_payment_digitally_with_udhaar_app:
    "Now you can collect payment digitally with Udhaar App",
  congratulations: "Congratulations!",
  did_not_receive_deposit_try_again: "Did not receive deposit? Try again",
  verify_account: "Verify Account",
  video: "Video",
  waiting_for_code_2: "Waiting for code",
  camera_permission:
    "Please allow the permission to access your camera from settings",
  invite_sent: "Invite Sent",
  user_already_user_udhaar: "This contact is already a user of Udhaar",
  rs_20_earned: "Rs. 20 Earned",
  invite: "Invite",
  remark: "Remark",
  remark_is_required: "Remark is required",
  total_cash_in: "Total cash in",
  total_cash_out: "Total cash out",
  save_invoice: "Save Invoice",
  add_item_list: "Add Item List",
  enter_invoice_total: "Enter Invoice Total",
  has_this_invoice_been_paid: "Has this invoice been paid?",
  add_customer_2: "Add Customer",
  add_items_to_invoice: "Add Items to Invoice",
  stock: "Stock",
  pcs: "Pcs",
  create_new_stock_item: "Create New Stock Item",
  import_items: "Import Items",
  selling_price_optional: "Selling Price (optional)",
  cost_price_optional: "Cost Price (optional)",
  current_stock_optional: "Current Stock (optional)",
  qty_for_low_stock_alert: "Qty for low stock alert",
  items_total: "Items Total",
  confirm_invoice_amount: "Confirm Invoice Amount",
  your_invoice_amount_is: "Your invoice amount is",
  invoice_successfully_saved: "Invoice Successfully Saved!",
  send_invoice: "Send Invoice",
  create_new_invoice: "CREATE NEW INVOICE",
  share_invoice: "Share Invoice",
  do_not_share: "Do not share",
  invoice_book_report: "Invoice Book Report",
  final_balance: "Final Balance",
  mobile_phone_number: "Mobile phone number",
  item_list_tafseel: "Item list (optional)",
  send_free_sms_to: "Send free SMS to ",
  only_you_and: "Only you and",
  can_see_these_entries: "can see these entries",
  add_first_transaction_of: "Add first transaction of ",
  cashbook_description:
    "Easily manage your sales & expenses. Now keep track of all your cash safely & securely.",
  invoicebook_description:
    "Create professional invoices for free. Share with customers and get paid 3X faster.",
  udhaarbook: "Udhaar Book",
  cash_in_caps: "Cash In",
  cash_out_caps: "Cash Out",
  all_items: "All items",
  out_of_stock: "Out of stock",
  stock_of_goods: "Stock of goods",
  manually_added: "Manually Added",
  manually_reduced: "Manually Reduced",
  manage_stock_items: "Manage Stock Items",
  add_new_item: "Add New Item",
  select_unit: "Select Unit",
  no_item_found: "No Item Found",
  delete_item: "Delete Item",
  all_data_of_this_item_will_be_deleted:
    "All data of this item will be deleted",
  manage_stock: "Manage Stock",
  collect_payment: "Collect Payment",
  share_promotions: "Share Promotions",
  win_daily_cash_prizes: "Win Daily Cash Prizes",
  unlock_cash_prize: "Unlock Cash Prize",
  switch_on_quiz_in_3_steps: "Switch ON quiz in 3 easy steps",
  start_using_udhaar_book: "Start using Udhaar Book",
  pakistans_biggest_cash_reward_app: "Pakistan's biggest cash reward app",
  play_quiz_and_win_cash_prizes_worth_10k:
    "Play Quiz and win cash prizes worth Rs.10,000",
  item_will_be_added_to_stock: "Item will be added to stock",
  customer_added_successfully: "customer added successfully",
  customer_deleted_successfully: "customer deleted successfully",
  invitation_successfull: "invitation send successfully",
  landmark: "Landmark",
  enter_landmark: "Enter Landmark (optional)",
  landmark_required_to_access_recharge:
    "Landmark is required to access recharge",

  send_money: "Send money",
  collect_money: "Collect money",
  balance_settled: "Balance Settled",
  create_new_item: "Create New Item",
  view_item: "View Item",
  save_items_to_invoice: "Save Items to invoice",
  infoAdded: "Information added Successfully",
  added: "added",
  Request_Send: "Request Send",
  are_you_sure_you_want_to_delete_business:
    "Are you sure you want to delete this business?",
  u_paisa: "Upaisa",
  going_back_will_discard_changes: "Going back will discard your changes",
  invoice_successfull: "Invoice Successful",
  amount_due: "Amount due",
  payment_due: "Payment Due",
  invoice_to: "Invoice to",
  purchase_order_to: "Purchase order to",
  amount_should_be_a_numbers: "Amount should be a number",
  select_invoice_method: "Select invoice status",
  info_updates: "information updated successsfully",
  info_added: "information added successsfully",
  info_deleted: "Information deleted successfully",
  unpaid: "Unpaid",
  close: "close",
  user_exist: "User already exist",

  easyLoad: "EasyLoad",
  ucash: "uCash",
  ucash_balance: "uCash Balance",
  view_details: "View details",
  sell_easyload: "Sell EasyLoad",
  earn_commission_upto_3: "Earn commission up to 2.5%",
  best_in: "Best in",
  ucash_descp:
    "Collect payment 3x faster. Earn extra cash with up to 1% cash back.",
  get_early_access: "Get Early Access",
  we_have_added_you_to_wait_list: "We have added you to wait list.",
  there_are: "There are",
  people_ahead_of_you_to_earn_upto_1_cashback:
    "people ahead of you to earn cashback of 1%.",
  want_fast_access: "Want fast access?",
  rp_50_recharge_ready: "Your recharge of 50 RS is ready!",
  avail_recharge_share_now:
    "To avail this recharge, share now with your friends and put these hashtags in the caption:",
  share_with_friends: "Share with friends",
  add_cash: "Add Cash",
  promotion: "Promotion",
  play_one_rupee: "Play 1 One rupee game",
  bill_payment: "Bill Payment",
  bill_payment_to_name: "Bill Payment to {name}",
  get_bill_discount: "Get up to Rs.12.25 on each bill",
  leaderboard: "Leaderboard",
  leaderboard_desc: "Do more recharge and get earn more money",

  sales_invoice: "Sales Invoice",
  expense_bill: "Expense Bill",
  business_Added_success: "Business Added",
  maximun_limit_10000: "Payment limit is between Rs. 100 and Rs. 10,000",

  transaction_paid_successfully: "Transaction paid successfully",
  do_you_want_to_delete_image: "Do you want to delete image",
  items_added_success: "items added successfully",
  no_item_found_add: "No item found.Add",
  stock_updated_success: "Stock updated successfully",
  stock_deleted_success: "Stock deleted successfully",
  stocks_deleted_success: "Stocks deleted successfully",
  business_deleted_success: "Business deleted sucsuccessfully",
  update_amount_with_item_total: "Update amount with item total?",
  date_time: "Date / Time",
  description: "Description",
  failed: "Failed",
  deposit: "Deposit",
  ucash_report: "uCash Report",
  total_easyload_given: "Total EasyLoad given",
  unable_to_get_wallet_balance: "Unable to get Wallet balance",
  ucash_list: "uCash Details",
  couldnt_request_early_access: "Could not request early access",
  easypaisa_account_number: "EasyPaisa Account Number",
  jazzcash_account_number: "JazzCash Account Number",
  enter_easypaisa_account_number: "Enter EasyPaisa account number",
  enter_jazzcash_account_number: "Enter JazzCash account number",
  your_account_number_is_easy_paisa_number:
    "Your account number is your EasyPaisa phone number",
  your_account_number_is_jazzcash_number:
    "Your account number is yourCreate New St JazzCash phone number",
  two_steps_away_from_percent: "You are 2 steps away from earning 2.5%",
  enter_deposit_amount: "Enter EasyLoad deposit amount",
  deposit_for_easyload: "Deposit amount for EasyLoad",
  enter_the_amount_you_want_to_deposit:
    "Enter the amount you want to deposit for EasyLoad",
  one_steps_away_from_percent: "You are 1 step away from earning 2.5%",
  confirm_transfer: "Confirm EasyLoad Transfer",
  easypaisa_will_send_you_a_pin: "EasyPaisa will send you a PIN",
  jazzcash_will_send_you_a_pin: "JazzCash will send you a PIN",
  enter_pin_easypaisa: "Please enter your pin in EasyPaisa app",
  enter_pin_jazzcash: "Please enter your pin in JazzCash app",
  amount: "Amount",
  from: "From",
  to: "To",
  your_easyload_account: "Your EasyLoad account",
  get_pin: "Get Pin",
  easyload_deposit_MPIN_confirm: "Confirm MPIN for Easyload deposit",
  request_mpin: "Request MPIN",
  verify_mpin: "Verify MPIN",
  did_not_recieve_mpin: "Did not recieve MPIN?",
  try_again: "Try again",
  open_easypaisa_and_enter_pin: "Open EasyPaisa and enter PIN",
  open_jazzcash_and_enter_pin: "Open JazzCash and enter PIN",
  waiting_for_you_to_verify_easyload_easypaisa:
    "Waiting for you to verify EasyLoad deposit amount on EasyPaisa app",
  waiting_for_you_to_verify_easyload_jazzcash:
    "Waiting for you to verify EasyLoad deposit amount on JazzCash app",
  deposit_failed_mpin_not_verified: "Deposit failed. MPIN not verified.",
  to_earn_35_on_easyload_verify_mpin:
    "To earn 2.5% on EasyLoad, verify your MPIN.",
  amount_deposited: "Amount Deposited",
  ucash_deposit: "uCash Deposit",
  done: "Done",
  setup_for: "Setup for",
  finish_hbl_payment: "Finish HBL payment setup in 5 easy steps.",
  earn_commission_upto_2: "Earn 2.5% commission",
  login_into_hbl: "Login into your HBL app",
  tap_on_more_btn: "Tap on 'MORE' button",
  select_corporate_payment: "Select 'Corporate Payment'",
  select_udhaar_app_from_dropdown: "Select 'Udhaar App' from dropdown",
  add_details_and_done: "Add details and you are done!",
  waiting_for_mpin: "Waiting for MPIN",
  add_ucash_balance: "Add uCash Balance",
  takeout_cash: "Takeout Cash",
  add_your_bank_account: "Add your bank account",
  to_change_bank_click_edit:
    "To add or change your account, click the edit icon",
  account_number: "Account number",
  enter_account_number: "Enter Account Number (ph#)",
  number: "Number",
  insufficient_balance: "Insufficient Balance",
  unable_to_withdraw: "Unable to withdraw",
  cash_take_out_successful: "Cash take out successful",
  cash_taken_out: "Cash Taken Out",
  cash_will_be_deposited_in_24_hours:
    "Cash will be deposited in your account within 24 hours",
  easyload_details: "EasyLoad Details",
  search_customer_by_phone: "Search customers by phone #",
  contact_not_found: "Contact not found",
  setup_easyload_and_earn_up_to_35: "Setup EasyLoad & Earn up to 2.5%",
  finish_easyload_setup_2_steps: "Finish EasyLoad setup in 3 steps",
  earn_upto_35_commission: "Earn up to 2.5% commission",
  step_one: "Step 1",
  step_two: "Step 2",
  step_three: "Step 3",
  tap_here: "Tap here",
  setup_screenlock: "Set up Screen Lock",
  enter_location: "Enter Location",
  location_is_mandatory: "Location is mandatory",
  location_permission: "Allow location permission from setting",
  add_balance_with_easypaisa_hbl_ubl:
    "Add Balance with EasyPaisa, JazzCash or HBL",
  easyload_and_earn_upto_35: "EasyLoad & Earn up to 2.5%",
  cash_back: "Cashback",
  recharge_report: "Recharge Report",
  udhaar_bonus: "Udhaar Bonus",
  load: "Recharge",
  package: "Package",
  packages: "Packages",
  select_a_package: "Select a Package",
  view_package_details: "View package details",
  unable_to_get_networks: "Unable to get networks",
  easyload_amount: "EasyLoad Amount",
  enter_easyload_amount: "Enter EasyLoad Amount",
  minimum_recharge_amount_limit_50: "Minimun Recharge amount limit is Rs. 50",
  package_summary: "Package summary",
  commission_details: "Commission Details",
  udhaar_book_cashback: "Udhaar Book Cashback",
  confirm_package: "Confirm Package",
  confirm_easyload: "Confirm easyload",
  sms_reciept_has_been_sent_to: "SMS Reciept has been sent to",
  easyload_dispute_descp:
    "Would you like to file a dispute against an EasyLoad transaction",
  active_disputes: "Active Disputes",

  pending_disputes: "Closed Disputes",
  would_you_like_to_file_a_dispute:
    "Would you like to file a dispute against the following transaction?",
  select_entry_to_file_dispute: "Select entry to file dispute",
  easyload_dispute_report: "EasyLoad Dispute Report",
  wallet_not_available: "Wallet not available",
  refresh: "Refresh",
  choose_category: "Choose Category",
  catalog_builder: "Catalog Builder",
  catalog_descp:
    "Choose and create your catalog from our already existing products",
  select_products: "Select Products",
  cnic_placeholder: "Enter 13 digits CNIC number",
  cnic_number_length: "cnic number should be 11 digits",
  sync: "Sync",
  Request_Send_success: "Your payment request has been sent via SMS",
  only_edit_from: "You can edit this transaction from",
  wallet_is_currently_not_available:
    "Wallet is currently not available. Please press the refresh button.",
  account_locked_description:
    "Your account is locked. Please contact us for details",
  not_editable: "You can't edit this transaction",
  dispute_active: "Active",
  dispute_completed: "Completed",
  syncing: "Syncing",
  data_sync_karein: "Sync your data",
  items_updated_success: "Items updated successfully",

  // Salary Book
  paybook: "Salary Book",
  add_staff_and_maintain_your_daily_attendance:
    "Add staff and maintain your daily attendance",
  add_staff: "ADD STAFF",
  total_present: "Total Present",
  total_absent: "Total Absent",
  staff_search_placeholder: "Staff (Search by name or phone #)",
  add_staff_lowercase: "Add Staff",
  this_number_associate_with_another_staff:
    "This number is associated with another staff",
  staff_name: "STAFF NAME",
  enter_staff_name: "Enter Staff Name",
  select_salary_type: "Select salary type",
  monthly: "Monthly",
  monthly_description:
    "Fixed salary, salary payment per month, monthly payment",
  weekly: "Weekly",
  weekly_description: "Weekly Payment, 7 days work cycle",
  daily: "Daily",
  daily_description: "Daily payment, payment on basis of number of days worked",
  hourly: "Hourly",
  hourly_description: "Punch In - Punch Out time, Hourly payment system",
  salary_type_is_required: "Salary type is required",
  enter_salary_amount: "Enter salary amount",
  enter_staff_salary: "Enter staff salary",
  staff_salary: "Staff/Salary",
  salary_is_required: "Salary is required",
  regular_working_hours: "REGULAR WORKING HOURS",
  select_your_hours: "Select your hours",
  working_hours_req: "Working hours is required",
  select_working_days: "SELECT WORKING DAYS",
  working_days_staff_can_be_marked:
    "Working days: Staff can be marked as Present or Absent",
  non_working_days_staff_can_be_marked:
    "Non-working days: Staff can be marked as Present or Paid Holiday",
  select_working_days_and_hours: "Select Working Days and Hours",
  select_working_days_small: "Select working days",
  save_staff: "Save Staff",
  joining_date: "Joining Date",
  select_joining_date: "Select Joining Date",
  staff_joining_date: "Staff joining date",
  staff_success_add: "Staff added successfully",
  all_staff: "All Staff",
  present: "Present",
  set_date_filter: "Set Date Filter",
  showing_staff_list_for: "Showing staff list for ",
  attendance: "Attendance",
  attendance_report: "Attendance Reports",
  staff_lowercase: "staff",
  presents: "Presents",
  absents: "Absents",
  days_lowercase: "days",
  paid_holiday: "Paid Holiday",
  not_marked: "Not Marked",
  advance_from_staff: "Advance from Staff",
  pending_to_staff: "Pending to Staff",
  closing_balance_small: " closing balance",
  balance_forward_from_last_month: "Balance forward from last month",
  rs: "Rs.",
  payments_small: " Payments",
  net_payments_given_and_taken_from_staff:
    "Net payments given and taken from staff",
  salary: "Salary",
  total_salary_if_no_presents:
    "Total Salary. If no presents have been marked, salary will be zero",
  pay_staff: "Pay Staff",
  salary_slip: "Salary Slip",
  salary_must_be_in_numbers: "Salary must be in numbers",
  salary_cannot_be_0: "Salary can not be 0",
  all_days: "All Days",
  mark_attendance_in_bulk: "Mark attendance in bulk",
  add_salary: "Add Payment",
  enter_salary_and_advance_payments_to_staff:
    "Enter salary and advance payments to staff",
  total_salary: "Total Salary",
  select_dates_for_salary_slip: "SELECT DATES FOR SALARY SLIP",
  staff_name_is_required: "Staff name is required",
  working_hours_are_required: "Working hours are required",
  working_hours_must_be_a_valid_number: "Working hours must be a valid number",
  working_hours_cannot_be_a_0: "Working hours can not be 0",
  profile_details: "Profile Details",
  staff_information: "Staff information",
  staff_name_lowercase: "Staff Name",
  name: "Name",
  job_title: "Job Title",
  salary_details: "Salary Details",
  salary_type_lowercase: "Salary Type",
  working_hours: "Working Hours",
  working_days: "WORKING DAYS",
  other: "Other",
  auto_present: "Auto Present",
  delete_staff: "Delete Staff",
  are_you_sure_you_want_to_delete_staff:
    "Are you sure you want to delete staff?",
  staff_deleetd_success: "Staff deleted successfully",
  staff_updated_successfully: "Staff updated successfully",
  no_data_for_date_range_was_found: "No data for date range was found!",
  are_you_sure_you_want_to_delete_this_payment:
    "Are you sure you want to delete this payment?",
  payment_deleted_successfully: "Payment Deleted Successfully",
  you_cant_schedule_a_payment_in_past:
    "You can't schedule a payment in the past.",
  you_paid: "You Paid",
  you_took: "You Took",
  payment_date: "Payment date",
  pay_online: "Pay Online",
  confirm: "Confirm",
  youre_about_to_transfer_salary_of: "You're about to transfer salary of ",
  add_staff_account: "Add Staff's Account",
  payment_success: "Payment saved successfully",
  edit_payment: "Edit Payment",
  daily_statement: "Daily statement",
  grand_total: "Grand Total",
  total_number_of_customers: "No. of Customer:",
  payment_details: "Payment Details",
  date_setted_success: "Date setted successfully",
  inventory_value: "Inventory value",
  inventory_cost: "Inventory Cost",
  stock_items: "Stock items",
  inventory_item: "Inventory Items",
  sale_report: "Sale Report",
  item_sold: "Item Sold",
  total_profit: "Total profit",

  // changes
  give_salary: "GIVE SALARY",
  give_advance: "GIVE ADVANCE",
  pay_cash: "Pay cash",
  pay_salary: "Pay salary",
  pay_advance: "Pay Advance",
  inventory_report: "Inventory Report",
  verify_cashout: "Verify Cashout",
  send_and_receive_payment: "Send and receive payments online",
  connect_wallet: "Connect Wallet",
  setup_screen_lock: "Setup screen lock",
  lock_is_mandatory: "Lock is mandatory",
  easypaisa: "EasyPaisa",
  jazzcash: "JazzCash",
  popular: "popular",
  please_enter_registered_number:
    "Please enter the mobile number registered with this account",
  connect_you_wallet: "Connect your Wallet",
  enter_password: "Enter password",
  create_new_password: "Create new password",
  re_confirm_password: "Re-confirm password",
  reenter_password: "Re-enter password",
  password_setted: "Password Created Successfully",
  one_steps_away_from_completion: "You are 1 step away from completion ",
  wallet_successful: "Wallet Connected Successfuly",
  whats_your_password: "What's your password?",
  enter_password_to_proceed: "Enter password to proceed to OTP screen",
  incorrect_password: "Incorrect password",
  please_enter_password: "please enter password",
  fee: "Fee",
  password: "Password",
  please_enter_your_pass: "Please enter your password",
  please_confirm_your_pass: "Please confirm your password",
  password_mismatch: "Passwords do not match. Please re-enter your password",
  verify_cashout_details: "Verify cashout details",

  staff_book: "Staff Book",
  working_hours_can_not_less_24: "Working hours can not be more than 24",
  date: "Date",
  unit: "Unit",
  cnic_number: "CNIC Number",
  suppliers_descp: "Add supplier and maintain your daily Udhaar",
  add_supplier: "Add supplier",
  this_number_associate_with_another_supplier:
    "This number associate with another supplier",
  supplier_added_successfully: "supplier added successfully",
  supplier_deleted_successfully: "supplier deleted successfully",
  create_suppliertitle: "Create Supplier",
  total_supplier: "Suppliers",
  supplier_name: "Supplier name",
  total_number_of_supplier: "No. of Supplier:",
  supplierprofileheading: "Supplier Profile",
  do_you_want_to_delete_supplier: "Do you want to delete supplier?",
  supplier_statement: "Supplier Statement",
  no_supplier_found: "No supplier found, Add ",
  no_filter_match_supplier: "No supplier matched your filter criteria",

  customer_to_supplier: "Customer converted to Supplier Successfully",
  supplier_to_customer: "Supplier converted to Customer Successfully",
  convert_to_customer: "Convert To Customer",
  convert_to_supplier: "Convert To Supplier",
  convert_all_supplier_entries_to_customer:
    "All entries of this Supplier will be transferred to the Customer section",
  convert_all_customer_entries_to_supplier:
    "All entries of this Customer will be transferred to the Supplier section",
  stock_description:
    "Add items and maintain stock. Ready-made item catalog. Profit report.",
  supplier_updated_successfully: "Supplier updated successfully",
  quantity: "Quantity",
  customer_depposit_success:
    "Money has been deposited into your customer's account",
  cnic_required: "CNIC is required",
  easypaisa_transaction_details: "Easypaisa transaction Details",
  enter_transfer_amount: "Enter transfer amount",
  easypaisa_in_out: "Easypaisa Money In/Out",
  business_type: "Business Type",

  selling_price_label: "Enter Selling Price (optional)",
  cost_price_label: " Enter Cost Price (optional)",
  category: "Category",
  no_customer_founds: "No customer found",
  lets_setup_your_udhaar_account: "Let’s set up your Udhaar account",
  pakistans_1_trusted_business_app: "Pakistan's #1 Businesses Platform",
  you_will_receive_OTP_code: "I will receive an OTP code",
  notes_optional: "Notes / Details (optional)",
  barcode_label: "Barcode (optional)",
  enter_category: "Enter category",
  Apna_insurance_plan_select_karein: "Select your insurance plan",
  Insurance_summary: "Insurance summary",
  View_insurance_plans: "View insurance plans",
  Request_submitted: "Request submitted",
  Humne_aapki_insurance_request_record_karli_hai_Humara_numainda_jald_aapse_rabta_karayga:
    "We have recorded your insurance request. Our representative will contact you soon.",
  Aap_ka_plan_already_subscribed_hai: "You are already subscribed to this plan",
  Already_subscribed: "Already subscribed",
  order_management: "Order management",
  order_management_capital: "Order Management",
  stock_management: "Stock Management",
  stock_management_small: "Stock management",
  orders: "Orders",
  returns: "Returns",
  order_accepted: "Order accepted",
  order_pending: "Order pending",
  order_returned: "Order returned",
  order_id: "Order id #",
  order_status: "Order status",
  total_price: "Total price",
  reject: "Reject",
  accept_small: "Accept",
  product_id: "Product ID",
  order_qty: "Ordered qty",
  calculation: "Calculation",
  sub_total: "Sub total",
  total_tax: "Total tax",
  discount: "Discount",
  customer_details: "Customer details",
  email_address: "Email address",
  delivery_address: "Delivery address",
  are_you_sure: "Are you sure,",
  you_want_to_reject_this_order: "you want to reject this order ?",
  order_reject: "Order Reject",
  please_share_ur_reason: "Please share your reason",
  add_note_to_the_order: "Add a note to the order",
  order_confirmation: "Order confirmation",
  you_want_to_confirm_order: "you want to confirm this order?",
  order_delivered: "Order delivered",
  select_reason: "Select reason",
  available_quantity: "Available qty",
  edit_item_quantity: "Edit item quantity",
  per_item: "Per item",
  enter_reason_here: "Enter reason here",
  order_payment_method: "Payment method",
  You_havent_placed_any_order_yet:
    "You don’t have any orders yet. Once you receive an order, it will appear here.",
  select_dispatch_date: "Select dispatch date",
  dispatch_date: "Dispatch date",
  date_of_purchase: "Date of purchase",
  tracking_id: "Tracking id",
  return: "Return",
  total_return_value: "Total return value",
  evidance_of_return: "Evidance of return",
  evidence: "Evidence",
  total_order_value: "Total order value",
  pending_on_customer: "Pending on customer",
  ready_to_ship: "Ready to ship",
  returned: "Returned",
  delivered: "Delivered",
  rejected: "Rejected",
  shipped: "Shipped",
  cancelled: "Cancelled",
  cod: "COD",
  return_management: "Return Management",
  you_have_not_received_any_return:
    "You haven't received any return orders, when a return occurs, their status will be displayed here.",
  received_customer_return: "Received customer return",
  awaiting_customer_return: "Awaiting customer return",
  add_new_stock: "Add new stock",
  upload_bulk_items: "Upload bulk items",
  upload_or_create_stock: "Upload bulk or create new stock",
  save_for_later: "Save for later",
  save_and_publich: "Save & publish",
  create_stock: "Create stock",
  sub_category: "Sub category",
  brand: "Brand",
  wholesale_price: "Wholesale price",
  msrp: "MSRP",
  minimum_order_qty_optional: "Minimum order qty",
  warranty_period_optional: "Warranty period (optional)",
  specification: "Specification",
  enter_specification: "Enter specification",
  delivery_date: "Delivery date",
  accepted: "Accepted",
  sku: "SKU",
  in_stock: "In stock",
  price: "Price",
  publish: "Publish",
  add_item_details: "Add item details",
  pricing: "Pricing",
  inventory: "Inventory",
  addtional_information: "Additional information",
  discount_optional: "Discount",
  page_not_found: "Page not found",
  we_re_sorry_the_page_you_requested:
    "We're sorry, the page you requested could not be found.",
  stock_image: "Stock image",
  upload_image: "Upload image",
  date_of_creation: "Date of creation",
  customer_tracking_id: "Customer tracking id",
  order_details: "Order details",
  seller_tracking_id: "Seller tracking id",
  creation_date: "Creation date",
  purchase_date: "Purchase date",
  evidence_image: "Evidence image",
  evidence_video: "Evidence video",
  publish_all: "Publish all",
  edit_stock: "Edit stock",
  qty_available: "Qty available",
  item_specification: "Item specification",
  warranty_period: "Warranty period",
  minimum_order_quantity: "Minimum order quantity",
  unpublished: "unpublished",
  waiting_approval: "Waiting for approval",
  delivery_add: "Address",
  managing_your_inventory_has_never:
    "Managing your inventory has never been easier with Udhaar book",
  start: "Start",
  wasooli_tez_safe: "3x faster collection. 100% safe.",
  print_label: "Print label",
  publish_item: "Publish item",
  would_you_like_to_publish_this: "Would you like to publish this item",
  would_you_like_to_publish: "Would you like to publish",
  on_your_catalog: "on your catalog ?",
  would_you_like_to_delete: "Would you like to delete",
  this_item: "this item",
  all_selected_item: "all selected items",
  upload_photo: "Upload photo",
  msrp_optional: "MSRP (optional)",
  terms_and_conditions_optional: "Terms and conditions (optional)",
  search_stock_by_name: "Search stock by name",
  delivery_charges: "Delivery charges",
  partner_markup: "Partner markup",
  return_policy_and_warranty_details: "Return policy and warranty details",
  order_filter: "Order filter",
  pdf_option: "Pdf option",
  search_by_order_number_customer_product:
    "Search by order #, customer or product",
  mark_as: "Mark as",
  you_want_to_ship_this_order: "you want to ship this order?",
  print_bill: "Print bill",
  print_loadsheet: "Print loadsheet",
  courier: "Courier",
  in_out: "In / Out",
  saddar_orders: "Saddar Orders",
  saddar_inventory: "Saddar Inventory",
  saddar: "Saddar",
  saddar_managenet: "Saddar Management",
  saddar_seller_central: "Saddar seller central",
  veiw_orders: "View Orders",
  download_template: "Download the template",
  in_the_file: "in the file ?",
  file_zip: "File.zip",
  uploading_with_dot: "Uploading",
  download_invoice: "Download Invoice",
  weight_gm: "Weight (gm)",
  select_weight_type: "Select weight type",
  please_select_order_weight: "Please select order weight",
  select_parcel_type: "Select parcel type",
  please_select_parcel_type: "Please select parcel type",
  ship_order: "Ship order",
  un_publish: "Un publish",
  add_variants: "Add variants",
  stock_variants: "Variants",
  placeholder_item_name: "e.g. Powerbank",
  placeholder_item_category: "Choose category",
  placeholder_item_subcat: "Choose sub category",
  placeholder_item_brand: "Choose brand",
  placeholder_item_price: "e.g. Rs. 1000",
  placeholder_item_discount: "e.g. Rs. 100",
  placeholder_item_quantity: "e.g. 25",
  placeholder_item_moq: "e.g. 5",
  placeholder_item_weight: "e.g. 550 gm",
  placeholder_item_warranty: "Select warranty period",
  placeholder_item_detail: "e.g. 20,000 mAh fast charging",
  placeholder_item_return_policy: "Type warranty and return details here",
  discount_more_than_price: "Discount amount can not be more than Price!",
  view_ledger: "View Ledger",
  ledger: "Ledger",
  search_by_desc_amount_balance: "Search by description, amount or balance",
  ledger_entries: "Ledger entries",
  actions: "Actions",
  time: "Time",
  ledger_management: "Ledger Management",
  ledger_non_ideal_desc:
    "You don't have any entry in the ledger at the moment, when any transaction happens, it will be displayed here.",
  search_by_desc: "Search by description",
  search_by_item_name: "Search by item name",

  // Sale Book
  open_item: "Open item",
  stock_item: "Stock item",
  sale_pos: "Sale POS",
  draft_sale: "Draft sales",
  sale_items: "Sale items",
  item_non_ideal_desc: "Please add items into the list",
  enter_open_amount: "Enter open item amount",
  current_sale: "Current sale",
  clear_item: "CLEAR ITEMS",
  pos_clear_all_items_title: "Clear all items?",
  pos_clear_all_items_body:
    "Are you sure you want to clear all items from the list?",
  new_sale: "New sale",
  checkout: "Checkout",
  order_summary: "Order summary",
  item_name: "Item name",
  tax: "Tax",
  payment_successfully: "Payment successful",
  amount_paid: "Amount paid via",
  change: "Change",
  print_recipt: "PRINT RECEIPT",
  online_payment_checkout: "Record your sale as online payment",
  udhaar_checkout: "Record your sale as Udhaar",
  bill_amount: "Bill amount",
  online_payment: "Online payment",
  start_selling: "Start selling items",
  create_stock_book_item: "Create items in inventory or start selling open items",
  sell_open_item: "SELL OPEN ITEMS",
  start_creating_item: "START CREATING ITEMS",
  error_message_more_than_10digits: "Error: Can’t add more than 10 Digits",
  order_history: "Order history",
  max_limit_reached: "Max limit reached",
  draft_message: "Do you want to save this order into draft sales?",
  discard: "DISCARD",
  no_draft_sale: "No draft sales to display",
  no_draft_sale_desc: "You haven’t had any draft sales yet.",
  on_going_sale: "Ongoing sale",
  on_going_sale_desc:
    "Do you want to save this sale before continue the another sale?",
  sale_history: "Sales history",
  no_order_history: "No order history to display",
  no_order_history_desc: "You haven’t had any order history yet.",
  order_history_detail_desc:
    "Click on sale from the list to view sale details.",
  order_no: "Order no",
  pos_order_no: "Order no.",
  sale_details: "Sale details",
  download_recipt: "Download receipt",
  print_receipt: "Print receipt",
  sales_history: "Sales history",
  sale_book: "Sale Book",
  print_invoice: "Print invoice",
  pay_bill: "Pay bill",
  pay_remaining: "Pay remaining",
  open_free_account: "Open free account",
  remaining_payment: "Remaining payment",
  you_have_received_cashback: "You have received Rs. {amount} cashback!",
  create_account_claim_rewards_note: "Create a Rupin account to claim rewards and earn on bill payments.",
  activate_your_wallet: "Activate your wallet",
  activate_wallet_note: "Get instant access to send, receive, and manage payments",
  activate_wallet: "Activate wallet",
  low_stock_report: "Low stock report",
  low_stock_item_value: "Low stock items value",
  stock_in: "Stock in",
  stock_out: "Stock out",
  stock_value: "Stock value",
  stock_report: "Stock report",
  total_items: "Total items",
  sales_report: "Sales report",
  no_result_found: "No result found",
  to_adjust_your_filter:
    "Try adjusting your filter to find what you’re looking for.",
  stock_book: "Stock Book",
  stock_in_out: "Stock in / out",
  bulk_upload: "bulk upload",
  create_item: "Create Item",
  low_stock: "Low stock",
  total_stock_items: "Total stock items",
  low_stock_items: "Low stock items",
  low_stock_value: "Low stock value",
  add_quick_item: "Add quick item",
  create_stock_item: "Create Stock Item",
  change_image: "Change image",
  secondary_unit: "Secondary unit",
  sell_rs: "Sell (Rs.)",
  costs_rs: "Cost (Rs.)",
  barcode_number: "Barcode number",
  expiry_date: "Expiry date",
  expiry_alert: "Expiry alert",
  batch_number: "Batch number",
  manufacturing_date: "Manufacturing date",
  filter_sort: "Filter & Sort",
  view_invoice: "view invoice",
  tax_added: "Tax added",
  add_tax: "Add tax",
  disount_added: "Discount added",
  add_dicount: "Add discount",
  subtotal: "Subtotal",
  enter_cash_amount: "Enter cash amount",
  charge_rs: "Charge RS",
  charge_amount_shortcut: "Charge RS. {amount} (Shift + Enter)",
  enter: "Enter",
  shift: "Shift",
  stock_list_desc: "Do you want to update the item price in the stock list as well?",
  online: "online",
  paid_via: "Paid via",
  search_order: "Search by customer name, amount, or sale number",
  saleID: "sale ID",
  search_items: "Search items",
  no_result: "No results found",
  create: "Create",
  as_new_item: "as new item",
  date_range: "Date range",
  additional_details: "Additional details",
  order_history_not_found: "Order history not found",
  this_product_has_options_like_size_or_color:
    "This product has options like size or color",
  account_overview: "Accounts overview",
  stock_overview: "Stock overview",
  dat_set_karein: "select date",
  as_customer: "as customer",
  save_changes: "save changes",
  discard_changes: "discard changes",
  upload_stock_items:
    "Upload your file or download the template for help formatting your items",
  upload_file: "Upload the file",
  select_file_or_drag: "Select a file or drag and drop here",
  min_validation_message: "can't be less than",
  file_size_validation: "File size no more than",
  image_format_valid: "Please select a valid image file (JPEG, PNG, or JPG)",
  as_supplier: "as supplier",
  supplier: "Supplier",
  enter_phone_number: "Enter phone number",
  enter_customer_name: "Enter customer name",
  enter_supplier_name: "Enter supplier name",
  type_name: "Type name",
  udhaar_payment_success: "This transaction also added in Accounts",
  order: "Order",
  max_validation_message: "can't be greater than",
  cant_be: "can't be",
  yearly: "Yearly",
  overview: "Overview",
  purchases: "purchases",
  non_ideal_graph_udhaar_title: "Can't see your Udhaar records?",
  non_ideal_graph_udhaar_subtitle:
    "Record now and view your Udhaar records for the selected period",
  graph_udhaar_btn_title: "Record Udhaar",
  non_ideal_acc_udhaar_title: "Who owes you Udhaar?",
  non_ideal_acc_udhaar_subtitle:
    "Add customers now and record Udhaar with them",
  pending_accounts: "Pending accounts",
  amount_in_rs: "Amount in Rs.",
  low_stock_item: "Low stock items",
  non_ideal_dash_stock_title: "Keep an eye on every item",
  non_ideal_dash_stock_subtitle:
    "Whether stock is low or high, keep an eye on it at all times",
  non_ideal_graph_sale_title: "See your sales growth",
  non_ideal_graph_sale_subtitle: "Track your sales growth in real time",
  non_ideal_dash_sale_title: "Stay informed about your top items",
  non_ideal_dash_sale_subtitle: "Which of your items is in the highest demand?",
  add_top_item: "add top item",
  top_sale_item: "Top sale items",
  non_ideal_dash_purchase_title: "See all your purchases in an instant",
  non_ideal_dash_purchase_subtitle:
    "What you buy for, what you sell for, and how much profit you make, see it all in one place",
  cost_rs: "Cost (Rs.)",
  sale_rs: "Sale Rs.",
  profilt_rs: "Profit Rs.",
  sale_invoice: "Sale invoice",
  contact_no: "Contact no",
  due_date: "Due date",
  customer_created: "Customer created successfully",
  supplier_created: "Supplier created successfully",
  enter_total_amount_error: "Please enter Items or Total Amount",
  quantity_error: "Price or Quantity can not be 0",
  not_available: "Not available",
  item_discount_error: "Discount cannot be greater than the item price.",
  enter_tax: "Enter tax",
  cash_small: "cash",
  write_name: "Write name",
  enter_paid_amount: "Enter paid amount",
  enter_recieved_amount: "Enter received amount",
  summary: "Summary",
  balance_amount_error:
    "Received amount cannot be greater than the total amount",
  expense_balance_amount_error:
    "Paid amount cannot be greater than the expense amount",
  sale_balance_amount_error:
    "Paid amount cannot be greater than the sale amount",
  sort: "Sort",
  delivery_challan: "Delivery challan",
  record_payment: "Record payment",
  send_payment: "Send Payment",
  print: "print",
  enter_received_amount: "Enter received amount",
  discard_invoice_desc:
    "Are you sure you want to discard this invoice? This action cannot be undone.",
  discard_invoice_title: "Discard invoice",
  discard_bill_title: "Discard bill",
  discard_invoice_btn: "Yes, discard this invoice",
  discard_bill_btn: "Yes, discard this bill",
  discard_transaction_btn: "Yes, discard this transaction",
  discard_transaction_title: "Discard transaction",
  discard_contact_btn: "Yes, discard this contact",
  discard_contact_title: "Discard contact",
  max_length_6digit: "Max length: 6 digits",
  pos_sales: "POS (sales)",
  inout: "In / Out",
  already_exist_item:
    "This item already exists. Duplicate items are not allowed",
  enter_quantity: "Enter quantity",
  enter_price: "Enter price",
  go_back_invoice_listing: "Go back to invoice listing",
  go_back_bill_listing: "Go back to bill listing",
  go_back_invoice_report: "Go back to  report",
  non_ideal_invoice_book:
    "Try search the item with another name to find what you’re looking for.",
  non_ideal_bill_book:
    "Try search the bill with another name to find what you’re looking for.",
  create_invoice: "Create Invoice",
  create_bill: "Create bill",
  preview: "Preview",
  create_purchase_bill: "Create purchase bill",
  edit_purchase_bill: "Edit purchase bill",
  edit_sale_invoice: "Edit sale invoice",
  edit_invoice: "Edit invoice",
  edit_bill: "Edit bill",
  max_20_character: "Max: 20 characters",
  type_signature_name: "Type signature name",
  invoice_date: "Invoice date",
  po_date: "PO date",
  invoice_items: "Invoice items",
  purchased_items: "Purchased items",
  amount_received: "Amount received",
  partial_paid: "Partial paid",
  units: "Units",
  farokht: "Sale",
  no_items_have_been_added_to_this_invoice_yet:
    "No items have been added to this invoice yet",
  no_items_have_been_added_to_this_bill_yet:
    "No items have been added to this bill yet",
  click_edit_invoice_to_include_the_items_you_billing_for:
    "Click ‘Edit Invoice’ to include the items you’re billing for.",
  click_edit_bill_to_include_the_items_you_billing_for:
    "Click ‘Edit bill’ to include the items you’re billing for.",
  no_products_were_added_to_this_invoice:
    "No products were added to this invoice",
  you_can_only_add_items_to_an_invoice_while_its_unpaid:
    "You can only add items to an invoice while it’s unpaid.",
  report_download: "Report Successfully Downloaded",
  backup_in_progress_shortly: "Backup in progress. Please try again shortly",
  error_downloading_report: "Error downloading report",
  successfully_download_invoice: "Successfully Downloaded Invoice",
  create_sale_invoice: "Create sale invoice",
  want_to_create_purchase_bill:
    "Want to create a purchase bill instead? Click here",
  want_to_create_sale_invoice:
    "Want to create a sale invoice instead? Click here",
  create_my_first_invoice: "Create my first invoice",
  create_my_first_bill: "Create my first bill",
  start_by_creating_invoice:
    "Start by creating an invoice and keep track of your payments and profits in one place",
  are_you_sure_you_want_to_delete_item:
    "Are you sure you want to delete this item?",
  contact_number: "Contact number",
  address_business: "Address",
  edit_customer: "Edit customer",
  update_record_sucessfully: "Update record sucessfully",
  amount_rs: "Amount Rs.",
  please_enter_item_name_first: "Please enter item name first!",
  only_one_unit_for_the_selected_item: "Only one unit for the selected item",
  reset_discount_message: "Reset item discount",
  close_without_saving: "Close without saving?",
  invoice_no: "Invoice no",
  item_report: "Item report",
  available_stock: "Available stock",
  low_stock_alert: "Low stock alert",
  profile_tracker: "Profit Tracker",
  total_item_sold: "Total items sold",
  total_item_purchases: "Total purchases price",
  total_sale_price: "Total sale price",
  stock_history: "Stock History",
  custom_date: "Custom date",
  stock_list: "Stock list",
  create_stock_item_details: "Create stock item details",
  edit_stock_item_details: "Edit stock item details",
  stock_book_reports: "Stock Book Reports",
  unsaved_changes: "You have unsaved changes",
  unsaved_changes_go_back_message: "You have unsaved changes. Are you sure you want to go back",
  discard_stock: "Yes, discard this stock",
  go_back_item: "Go back to item listing",
  create_as_item: "Create this as new item",
  add_more_item_detail: "Add More Item Details",
  add_more_item_detail_desc:
    "Click the + icon to add a new column and include additional details for your item.",
  please_select_primary_unit_first: "Please select the primary unit first",
  secondary_unit_cannot_be_same_to_primary_unit:
    "Secondary unit cannot be the same as the primary unit",
  primary_unit_cannot_be_same_to_secondary_unit:
    "Primary unit cannot be the same as the secondary unit",
  You_can_add_your_custom_unit: "You can add your custom unit",
  item_not_found: "Item not found",
  sorry_could_not_find: "Sorry, we couldn't find",
  you_can_add_stock: "You can add it to your stockbook by clicking below!",
  stock_filter_non_ideal_screen:
    "Try modifying your filters or clearing them to explore all options.",
  no_report_found: "No report found",
  stock_report_non_ideal_decs:
    "No stock data available. Please add items to your inventory",
  add_items_now: "Add Items Now",
  sale_report_non_ideal_decs:
    "No sales data found. Start making sales to generate reports",
  no_low_stock_found: "No low stock found",
  low_stock_report_non_ideal_decs:
    "No low stock items found. All your products are well-stocked",
  add_unit: "Add unit",
  unit_modal_desc:
    "If this item is available in another unit, you can add it here.",
  unit_conversion_error: "Unit conversion  cannot be zero",
  manufactor_lower_expiry_validation_msg:
    "Manufacturing date must be lower than expiry date",
  expiry_greater_manufactor_validation_msg:
    "Expiry date must be greater or equal than manufacturing date",
  expiry_alert_lower_expiry_validation_msg:
    "Expiry alert must be lower or equal than expiry date",
  are_you_sure_you_want_to_leave_this_screen:
    "Are you sure you want to leave this screen and discard your changes?",
  item_deleted_successfully: "Item deleted successfully",
  loss_profit: "Loss/ Profit",
  action: "Action",
  create_your_pin: "Create your PIN",
  confirm_your_pin: "Confirm your PIN",
  setup_pin_security: "Set up a PIN for your security",
  create_pin: "Create PIN",
  setup_pin: "Setup PIN",
  pin_code: "PIN code",
  activated: "Activated",
  it_ensure_that_no_one_else_can_access: "It ensures that no one else can access your account",
  turn_off: "Turn off",
  change_pin: "Change pin",
  start_by_creating_purchase_invoice:
    "Start by creating an purchase bill and keep track of your payments and profits in one place",
  package_details: "Package details",
  package_done: "Package done",
  package_successfully: "Package is successfully completed",
  delete_single_item: "Are you sure you want to delete this item?",
  delete_multiple_items: "Are you sure you want to delete these items?",
  mobile_recharge: "Mobile Recharge",
  continue: "Continue",
  business_trust: "Trusted by 5.3M+ businesses",
  Verify_OTP: "Verify OTP",
  otp_code_sent: "We have sent OTP to your",
  enter_4_digit_otp_code: "Enter 4 digit OTP code here",
  wait_time: "Wait time",
  money_khaata_is_updated: "Money’s in — your khaata is updated",
  payment_received_successfully: "Payment received successfully!",
  inventory_updated_with_received_items:
    "Inventory updated with received items",
  whatsapp_number: "Whatsapp number",
  your_data_is_being_restored: "Your data is being restored",
  secured_data_transmission_in_progress:
    "Getting your numbers ready!",
  please_confirm_4_digit_pin: "Please confirm your 4 digits Udhaar book PIN",
  forget_pin: "Forget PIN?",
  back_to_login: "Back to login",
  call_support: "Call  support",
  verify_your_account: "Verify your account",
  verify_your_account_decs:
    "Complete your verification through the Udhaar Book app to reset your PIN. This helps us ensure the security and authenticity of your account.",
  scan_to_open: "Scan to open",
  search_udhaar_book_on_play_store: "Search Udhaar book on Play store",
  or_download: "Or download",
  just_need_few_detail_to_get_started:
    "Just need a few details to get you started",
  kareen_store: "Kareen store",
  otp_verified_successfully: "Your OTP has been successfully verified",
  verify_PIN: "Verify PIN",
  Please_verify_your_4_digits_Udhaar_book_PIN:
    "Please verify your 4 digits RUPIN PIN",
  tries_left: "tries left",
  call: "Call",
  Select_the_options_below_to_receive_a_new_OTP:
    "Select the options below to receive a new OTP",
  phone_sms: "Phone SMS",
  we_will_call_for_OTP_to_your: "We will call for OTP to your",
  hang_tight_ledgers: "Hang tight – your ledgers are almost ready!",
  sale: "Sale",
  keyboard_shortcuts: "Keyboard shortcuts",
  keyboard_shortcut_tooltip: "Keyboard shortcut",
  shortcut_switch_tabs: "Switch between the tabs",
  shortcut_add_items_to_cart: "Add items to cart",
  shortcut_start_new_sale: "Start new sale",
  shortcut_go_to_checkout: "Go to checkout",
  shortcut_search_items: "Search items",
  shortcut_scroll_up_items: "Scroll up items list",
  shortcut_scroll_down_items: "Scroll down items list",
  shortcut_scroll_up: "Scroll up",
  shortcut_scroll_down: "Scroll down",
  shortcut_add_customer: "Add customer",
  shortcut_charge: "Charge",
  available: "Available",
  delete_bill: "Delete bill",
  delete_invoice: "Delete invoice",
  retry: "Retry",
  suppliers_descp_new:
    "Add suppliers and manage your purchasing. Free payment reminders. Collections 3x faster.",
  add_customer_descp_new:
    "Add customers and manage their accounts. Free payment reminders. Collections 3x faster.",
  i_will_give: "I will give",
  i_will_receive: "I will receive",
  welcome_to_accounts: "Welcome to accounts",
  add_customer_supplier_collection:
    "Add your customers and suppliers to keep collections smooth and credit stress-free.",
  suppliers: "Suppliers",
  contact_type: "Contact type",
  status: "Status",
  download_files: "Download Files",
  payment_pdf: "Payment PDF",
  payment_detail: "Payment Detail",
  outstanding_orders: "Outstanding Orders",
  return_orders: "Return Orders",
  enter_weight: "Enter weight",
  weight_type: "Weight type",
  select_dimensions: "Select dimensions",
  dimension_type: "Dimension type",
  length: "Length",
  width: "Width",
  height: "Height",
  customers_statement: "Customers Statement",
  suppliers_statement: "Suppliers Statement",
  itook: "I Took",
  igave: "I Gave",
  received: "Received",
  details: "Details",
  invoice_terms_label: "Terms",
  You_are_all_set: "You're All Set!",
  txns_non_ideal_desc:
    "has been added successfully. Start tracking transactions with your customer now.",
  transaction_for: "Transaction for",
  note_placeholder: "Add detailed note here",
  add_image: "Add image",
  upload_new_file: "Upload new file",
  transaction_detail: "Transaction details",
  expense_date_time: "Expense date & time",
  notes: "Notes",
  type: "Type",
  contact_list_non_ideal_title: "Allow Contacts permission from phone",
  contact_list_non_ideal_description:
    "Provide permission from the Udhaar Book app to add all contacts in one go",
  sync_contacts: "Sync contacts",
  hang_on: "Hang on!",
  your_contacts_are_being_synced: "Your contacts are being synced",
  edit_contact: "Edit contact",
  send: "Send",
  message: "Message",
  message_description:
    "Asalam o Alaikum!You have an outstanding amount of Rs. 855 with Book Ocean. Kindly clear your dues at your earliest convenience.Thank you!",
  reminder_type: "Reminder type",
  phone: "Phone",
  due_date_set: "Due date has been set",
  due_date_remove: "Due date has been removed",
  collection_date_set: "Collection date has been set",
  collection_date_remove: "Collection date has been removed",
  we_could_not_find_match: "We couldn’t find any matches for",
  supplier_with_this_number_already_exists:
    "Supplier with this number already exists",
  customer_with_this_number_already_exists:
    "Customer with this number already exists",
  you_can_either_view_supplier_details_or_move_to_customer_tab:
    "You can either view supplier details or move to customer tab",
  you_can_either_view_customer_details_or_move_to_supplier_tab:
    "You can either view customer details or move to supplier tab",
  move_to_customer: "Move to customer",
  move_to_supplier: "Move to supplier",
  view_supplier: "View supplier",
  view_customer: "View customer",
  i_will_recieve: "I will receive",
  no_more_notebooks_or_spreadsheets: "No More Notebooks or Spreadsheets",
  your_customers_forget_to_pay: "Your Customers Forget to Pay You?",
  never_again: "Never Again!",
  watch_tutorial: "Watch Tutorial",
  five_million_strong: "5.5 Million Strong",
  and_growing_every_day: "- And Growing Every Day",
  no_more_notebooks_spreadsheets: "No More Notebooks or Spreadsheets",
  no_more_notebooks_spreadsheets_description:
    "Keep your receivables and payables organized. Send reminders, record payments, and stay updated on your khata.",
  easy_payment_tracking: "Easy Payment Tracking",
  easy_payment_tracking_description:
    "Quickly add incoming and outgoing payments, with categories to keep your records organized and up-to-date.",
  real_time_account_balances: "Real-Time Account Balances",
  real_time_account_balances_description:
    "Quickly track what customers owe you and what you owe suppliers, all on one simple and easy-to-use screen!",
  a_community_full_of_stories: "A community full of stories",
  testimonial_one:
    "I used to forget who still had to pay me, and it was hard to keep track. Now, I can see all my receivables in one place and even send reminders. It’s made collecting payments so much easier!",
  testimonial_two:
    "I used to forget who still had to pay me, and it was hard to keep track. Now, I can see all my receivables in one place and even send reminders. It’s made collecting payments so much easier!",
  testimonial_three:
    "I don’t have to chase customers anymore. I set reminders, and the app does the rest. I even recovered payments I had forgotten about.",
  testimonial_four:
    "Tracking payments was a headache. Now, I get notified who hasn’t paid, and I just hit ‘Send Reminder’. It’s that simple.",
  create_your_inventory: "Create your inventory",
  low_stocks: "Low Stocks",
  forgot_to_update_them: "and Forgot to Update Them?",
  add_new_products_easily: "Add New Products Easily",
  add_new_products_easily_description:
    "Create items in just a few clicks. Enter product name, unit, price, and stock details quickly—no complexity involved.",
  low_stock_reports: "Low Stock Reports",
  low_stock_reports_description:
    "See what needs restocking at a glance.Generate low-stock reports to plan your purchases and avoid missed sales.",
  quick_stock_adjustment: "Quick Stock Adjustment",
  quick_stock_adjustment_description:
    "Easily update stock quantities anytime.Manually correct stock counts with a few clicks for damaged, lost, or returned items.",
  testimonial_five:
    "I used to struggle with tracking payments and stock manually. Now everything’s in one place—this app is a lifesaver.",
  testimonial_six:
    "Before this, I wrote stock on paper. I always forgot what I sold. Now everything’s logged, and I can see low stock instantly.",
  testimonial_seven:
    "I love the quick item feature. When I’m selling something new, I don’t need to fill everything—just sell and go!",
  testimonial_eight:
    "Adding stock used to take time. Now, I just hit ‘Stock In’ and update everything. No more guesswork.",
  add_sale: "add sale",
  mixing_up_your_sales: "Mixing Up Your Sales?",
  let_simplify_that: "Let’s Simplify That",
  make_sales_second: "Make Sales in Second",
  make_sales_second_description:
    "Handle walk-in sales fast—select items, enter payment type, and instantly print or share the receipt. Perfect for counter and cash sales.",
  send_invoices_get_paid_faster: "Send Invoices That Get Paid Faster",
  send_invoices_get_paid_faster_description:
    "Create professional invoices for your customers. Track due amounts, apply taxes or discounts, and manage credit sales effortlessly with detailed invoices.",
  track_every_rupee_coming: "Track Every Rupee Coming In",
  track_every_rupee_coming_description:
    "Record payments received from customers. Easily track partial or full payments against sales invoices and maintain a clear payment history for every customer.",
  testimonial_nine:
    "Creating and sharing invoices with customers takes just seconds. I no longer have to write anything down manually — the app does it all instantly and neatly.",
  testimonial_ten:
    "Daily sale entries are a breeze with this app. It fits perfectly into my workflow — I can add every sale on the go without missing a beat.",
  testimonial_eleven:
    "This app gives a crystal-clear summary of all my sales. I can review daily, weekly, or monthly progress in seconds, which really helps in making better decisions.",
  testimonial_twelve:
    "It’s easy to track how much cash I received for each sale. The app keeps all incoming payments organized and gives me confidence in my records.",
  no_transactions_to_show_yet: "No transactions to show yet",
  no_transactions_to_show_yet_subtitle:
    "Once you start  record payments, all your activity will appear here",
  go_to_accounts: "go to accounts",
  no_customer_records_yet: "No customer records yet",
  no_customer_records_yet_subtitle:
    "Add your customers in the Accounts section to track what they owe you and manage reminders easily.",
  no_supplier_records_yet: "No supplier records yet",
  no_supplier_records_yet_subtitle:
    "Add your suppliers in the Accounts section to track what you owe and never miss a payment.",
  add_purchase: "add purchase",
  expenses_piling_up: "Expenses Piling Up?",
  organize_and_optimize: "Organize and Optimize.",
  record_all_your_purchases_one_place: "Record All Your Purchases in One Place",
  record_all_your_purchases_one_place_description:
    "Track bills, supplier payments, and expenses easily. No more guesswork—log every outgoing transaction in seconds.",
  smart_stock_easy_purchasing: "Smart Stock, Easy Purchasing",
  smart_stock_easy_purchasing_description:
    "Record purchases from suppliers and update stock automatically. Log item-wise purchases, track dues, and keep your inventory accurate—all in one go.",
  stay_top_of_business_spending: "Stay on Top of Business Spending",
  stay_top_of_business_spending_description:
    "Track non-stock-related business spending. Whether it’s rent, salaries, or utility bills—record every outgoing payment to stay on top of your cash flow.",
  testimonial_thirteen:
    "I use this app to record all my purchases and payments. Everything from stock buying to rent is now documented — and it’s helped me manage my expenses like never before.",
  testimonial_fourteen:
    "One of my favorite features is how it creates reports of all purchases. I can go back and view complete spending history anytime I need, which makes things very transparent.",
  testimonial_fifteen:
    "The ability to generate and send purchase orders directly from the app has made my business much more professional. I no longer have to write them by hand or send scattered messages.",
  testimonial_sixteen:
    "The app gives me full flexibility to mark how I paid — in full, partially, or on credit. This keeps my records accurate and gives me a true picture of my cash flow.",
  view_reports: "View reports",
  over_due_accounts: "Overdue accounts",
  customer_supplier: "Customer / Supplier",
  cta: "CTA",
  item_list: "item list",
  value_Rs_dot: "Value-Rs.",
  stock_value_report: "Stock value report",
  top_selling_items: "Top selling items",
  dashboard: "Dashboard",
  customers: "Customers",
  purchase: "Purchase",
  request_reports: "Request reports",
  report_name: "Report name",
  enter_report_name: "Enter report name",
  report_details: "Report details",
  enter_report_details: "Enter report details",
  quantity_sold: "Quantity sold",
  length_width_height: "Length x width x height inches",
  items_type: "Items type",
  unit_type: "Unit type",
  barcode: "Barcode",
  jpg_png_file_size_no_more_than: "JPG or PNG, file size no more than 3MB",
  value: "Value",
  date_filter: "Date Filter",
  current_quantity: "Current quantity",
  stock_in_quantity: "Stock in quantity",
  stock_out_quantity: "Stock out quantity",
  please_select_start_end_date: "Please select start and end date",
  barcode_error: "Barcode error",
  updated_stock_inventory: "Updated stock inventory",
  record: "Record",
  pos: "POS",
  pos_sale: "POS Sale",
  create_pos: "Create pos",
  pos_report: "POS report",
  number_of_transctions: "Number of transctions",
  expence: "Expence",
  purchase_bill_report: "purchase bill report",
  expence_report: "expense report",
  search_customers_by_name_or_posId_placeholder: "Search by name or POS#",
  invoice_report: "Invoice report",
  too_many_walk_ins: "Too Many Walk-Ins?",
  keep_them_smooth_with_pos: "Keep Them Smooth with POS",
  create_pos_sale: "Create POS sale",
  stock_item_in_pos: "Stock Item in POS",
  stock_item_in_pos_description:
    "Add items directly from your stock while making a sale. This way, your inventory updates automatically with every bill — so you always know what’s selling and what’s running low.",
  open_item_description:
    "Open Items are sales created but not yet fully paid. Easily track pending payments, send reminders, and update when customers pay, ensuring you always know which sales are open and the amount still due.",
  draft_sales: "Draft Sales",
  draft_sales_description:
    "Draft Sales let you save orders that aren't ready to be finalized, whether the customer is still deciding or you want to complete the sale later. Easily return to edit or confirm when the customer is ready.",
  forgot_invoices: "Forgot Invoices?",
  we_help_you_stay_on_track: "We’ll Help You Stay on Track.",
  sale_invoice_desc:
    "A Sales Invoice includes all details like items, quantities, prices, taxes, and total amount — so both you and your customer have a clear record of the transaction",
  share_instantly: "Share Instantly",
  share_instantly_desc:
    "Send invoices directly to your customers via WhatsApp, email, or print. No manual writing, no delays — your customer gets the bill right away",
  track_payments: "Track Payments",
  track_payments_desc:
    "Easily see which invoices are fully paid, partially paid, or still pending. This helps you stay on top of collections and follow up on due amounts without missing anything.",
  frustrated_with_unpacked_purchases: "Frustrated with Unpacked Purchases?",
  let_bring_order: "Let’s Bring Order",
  keep_records_organized: "Keep Records Organized",
  keep_records_organized_desc:
    "All purchase orders are stored in one place, so you can quickly check past orders, compare supplier prices, and maintain complete purchase history",
  send_suppliers_easily: "Send to Suppliers Easily",
  send_suppliers_easily_desc:
    "Create and share purchase orders with your suppliers in just a few clicks — through WhatsApp, email, or print. This keeps everything clear and professional.",
  track_pending_orders: "Track Pending Orders",
  track_pending_orders_desc:
    "See which orders are still open, which are delivered, and what’s due. This helps you manage your stock and cash flow more effectively.",
  purchase_expense: "Purchase & Expense",
  send_invoices: "Send Invoices",
  sale_pos_desc:
    "With POS, you can quickly create a receipt, record payment, and hand it over to the customer right away. It’s fast, simple, and perfect for walk-in customers.",
  sale_invoices: "Sale Invoices",
  purchase_bill_desc:
    "Stop chasing suppliers over phone calls or messages. With Purchase Bill, you can send clear, professional requests for goods — with items, prices, and quantities all in one place.",
  expenses: "Expenses",
  expenses_description:
    "An Expenses help you record money spent on running your business — like rent, utilities, salaries, or supplies. It keeps all your business expenses properly documented.",
  create_purchase: "Create purchase",
  lost_in_your_expenses: "Lost in Your Expenses?",
  stay_organized: "Stay Organized",
  create_expense: "Create expense",
  avoid_missed_entries: "Avoid Missed Entries",
  avoid_missed_entries_desc:
    "Record expenses as soon as they happen to ensure nothing is forgotten and your accounts remain accurate.",
  track_all_business_costs: "Track All Business Costs",
  track_all_business_costs_desc:
    "Easily enter and save every expense, big or small, so you always know where your money is going.",
  summary_of_your_cash_out: "Summary of Your Cash Out",
  summary_of_your_cash_out_desc:
    "See exactly how much money has gone out of your business at a glance. With a proper expense summary, you always know where your cash is flowing and can plan smarter.",
  record_expense: "Record expense",
  expense_amount: "Expense amount",
  select_category: "Select category",
  paid_amount: "Paid amount",
  company: "Company",
  company_supplier: "Company / Supplier",
  total_paid_expenses: "Total paid expenses",
  total_unpaid_expenses: "Total unpaid expenses",
  expense_id: "Expense ID",
  options: "Options",
  expense_report: "Expense report",
  delete_expense: "Delete expense",
  are_you_sure_you_want_to_delete_this_expense:
    "Are you sure you want to delete this expense record?",
  expense_has_been_successfully_recorded:
    "Expense has been successfully recorded",
  expense_has_been_successfully_updated:
    "Expense has been successfully updated",
  companies: "Companies",
  search_by_expense_id: "Search by expense #",
  additional_details_subtitle: "(Notes, upload image and date)",
  additional_details_subtitle_stock:
    "(Barcode, Expiry, Batch number, Wholesale price, Manufacturing date)",
  discard_expense_btn: "Yes, discard this expense",
  this_action_cannot_be_undone: "This action cannot be undone.",
  Are_you_sure_you_want_to_change_the_customer_to_supplier:
    "Are you sure you want to change the customer to supplier?",
  Are_you_sure_you_want_to_change_the_supplier_to_customer:
    "Are you sure you want to change the supplier to customer?",
  are_you_sure_delete_suppier: "Are you sure you want to delete this supplier?",
  are_you_sure_delete_customer:
    "Are you sure you want to delete this customer?",
  save_to_draft_sales: "Save to draft sales",
  delete_draft: "Delete draft",
  delete_draft_desc: "Are you sure you want to delete this draft sale?",
  search_by_order: "Search order",
  no_filter_match:
    "No results match these filters. Try adjusting or clearing filters",
  item_name_placeholder: "e.g. Sugar",
  select_to_type_or_add: "Select to type or add",
  primary_unit: "Primary unit",
  enter_number_to_send_reminder: "Enter number to send reminders",
  quantity_placeholder: "50",
  unit_placeholder: "e.g. Kg, Piece, Box",
  secondary_unit_placeholder: "e.g. Dozen, Carton",
  sell_rs_placeholder: "e.g. 120",
  cost_rs_placeholder: "e.g. 100",
  low_stock_alert_placeholder: "e.g. 10",
  enter_batch_number: "Enter batch number",
  clear_filters: "Clear filters",
  stock_in_updated: "Stock in updated",
  stock_out_updated: "Stock out updated",
  enter_or_create: "Enter or create",
  edit_expenses: "Edit expenses",
  id: "ID",
  try_another_filter_to_find_what_youre_looking_for:
    "Try another filter to find what you’re looking for.",
  select_company_or_supplier: "Select company or supplier",
  avb_stock: "Avb stock",
  delete_pos: "Delete POS",
  are_you_sure_you_want_to_delete_this_pos:
    "Are you sure you want to delete this POS",
  create_stock_book: "Create stock book",
  low_stock_report_non_ideal_decs_half: "No low stock items found.",
  back_to_report: "Back to report",
  no_sales_data_found: "No sales data found",
  create_a_sale_to_generate_report: "Create a sale to generate report.",
  create_sale: "Create sale",
  start_making_sales_to_generate_reports:
    "Start making sales to generate reports",
  expense_search_description:
    "Try searching with another name or number to find what you are looking for",
  create_search_term_as_new_customer: "Create '{name}' as new customer",
  create_search_term_as_new_supplier: "Create '{name}' as new supplier",
  go_back_to_expense_listing: "GO BACK to expense listing",
  remind_with_whatsapp_add_contact:
    "Please add a contact number to enable reminders via WhatsApp.",
  add_customer_to_sale: "Link a customer to share receipts quickly",
  go_back_to_quick_sale_listing: "GO BACK to quick sale listing",
  create_your_own_item: "Create your own item",
  catalog_items: "Catalogue items",
  preview_image: "Preview image",
  go_back_to_POS: "Go back to POS listing",
  non_ideal_pos_book:
    "Try search the POS with another name to find what you’re looking for.",
  backup_data: "Backup data",
  available_balance: "Available balance",
  add_money: "Add Money",
  request: "Request",
  easyload_packages: "Easyload & packages",
  bill_payments: "Bill payments",
  vouchers: "Vouchers",
  shop: "Shop",
  sms_bundles: "SMS bundles",
  see_more_bills: "See more bills",
  sell_vouchers: "Sell vouchers",
  search_transactions: "Search transactions",
  transaction_id: "Transaction ID",
  scan_and_add_money_to_your_wallet: "Scan and add money to your RUPIN account",
  account_title: "Account title",
  IBAN: "IBAN",
  copy: "Copy",
  last_trx_date: "Last trx date",
  due_today: "Due today",
  total_balance_due: "Total balance due",
  copy_details: "Copy details",
  collect_from: "Collect from",
  easy_QR_code_payments: "Easy QR code payments",
  share_details: "Share details",
  download_qr_code: "Download qr code",
  print_qr_code: "Print qr code",
  trusted_by_million_users: "Trusted by 5.3+ million users",
  licensed_by_State_Bank_of_Pakistan: "Licensed by State Bank of Pakistan",
  auto_reconciliation: "Auto reconciliation",
  send_anywhere: "Send anywhere",
  receive_anywhere: "Receive anywhere",
  free_and_instant: "Free & instant",
  your_account_just_got_an_upgrade: "Your account just got an upgrade.",
  it_only_takes_a_minute: "It only takes a minute",
  unlock_benefits_by_upgrading_your_account:
    "Unlock benefits by upgrading your account",
  licensed_by_sbp_in_principle: "Licensed by SBP (in principle)",
  upgrade_account: "Upgrade account",
  scan_qr_or_share_download_link: "Scan QR or share download link",
  copy_link: "Copy link",
  share_link: "Share link",
  upgrade_account_download_desc:
    "To upgrade your account, download the RUPIN App, scan the QR code, or copy and share the download link.",
  wallet_onboarding_b_slide1_title: "One wallet for every payment",
  wallet_onboarding_b_slide1_subtitle: "Track and manage with ease",
  wallet_onboarding_b_slide2_title: "Pay anywhere, anytime",
  wallet_onboarding_b_slide2_subtitle: "Fast, free and limitless transfers",
  wallet_onboarding_b_slide3_title: "Get money instantly. 100% free",
  wallet_onboarding_b_slide3_subtitle: "No fees, no limits",
  pending_collections_payments: "Pending collections & payments",
  search_contact: "Search contact",
  contact: "Contact",
  document_no: "Document no",
  total_money_in: "Total money in",
  total_money_out: "Total money out",
  money_in: "Money in",
  money_out: "Money out",
  new_entry_in: "New entry (In)",
  new_entry_out: "New entry (Out)",
  view_all: "View all",
  choose_mobile_network: "Select network",
  recharge_type: "Recharge type",
  network_service_currently_unavailable: "This service is currently unavailable for {network}",
  bank_name: "Bank name",
  account_details: "Account details",
  raast_id: "Raast ID",
  linked: "Linked",
  unlinked: "Not linked",
  link: "Link",
  linking: "Linking...",
  unlink: "Unlink",
  raast_id_unlink: "Unlink Raast ID",
  raast_id_unlink_desc: "Are you sure you want to unlink your Raast ID? You can link it again anytime.",
  raast_id_linked_successfully: "Raast ID linked successfully",
  raast_id_unlinked_successfully: "Raast ID unlinked successfully",
  enter_account_number_IBAN: "Enter account number / IBAN",
  enter_amount_rs: "Enter amount Rs.",
  enter_amount_here: "Enter amount here",
  insufficient_balance_please_try_different_amount:
    "Insufficient balance, please try different amount",
  go_to_wallet: "go to home",
  share_receipt: "share receipt",
  review: "Review",
  mobile_network_new: "Mobile network",
  select_customer: "Select customer",
  send_request: "Send request",
  pending_amount: "Pending amount",
  phone_number_already_exist:
    "Phone number already exist, please try different number",
  tired_of_payment_chaos: "Tired of payment chaos?",
  simplify_with_one_smart_wallet: "Simplify with one smart wallet.",
  let_get_started: "LEt’s get started",
  earn_money_on_every_transaction: "Earn money on every transaction",
  turn_every_recharge_the_more_you_earn:
    "Turn every recharge, bill payment, and voucher sale into extra income the more you sell, the more you earn.",
  track_every_transaction_effortlessly: "Track every transaction effortlessly",
  view_all_your_payments_stay_on_top_of_every_transaction:
    "View all your payments, Add Money, and send money in one place. Keep your business records organized and stay on top of every transaction.",
  send_money_anytime_anywhere: "Send money, anytime, anywhere",
  make_instant_payments_straight_without_delays_or_extra_steps:
    "Make instant payments straight from your wallet to any bank or wallet user. Fast, secure, and reliable, without delays or extra steps.",
  first_activate_your_wallet_in_3_easy_steps:
    "First activate your wallet in 3 easy steps",
  open_camera: "Open camera",
  and_scan_barcode: "and scan barcode",
  from_your_phone: "from your phone",
  udhaar_book_app_from: "Udhaar book app from ",
  play_store: "play store",
  tap_on_wallet_icon: "Tap on wallet icon",
  and_verify_KYC: "and verify KYC",
  download_app: "Download App",
  application_completed: "Application completed",
  application_ID: "Application ID",
  account_activation: "Account activation",
  your_account_will_be_activated_in: "Your account will be activated in",
  minutes: "minutes",
  select_package: "Select package",
  choose_package: "Choose package",
  hybrid: "Hybrid",
  data: "Data",
  social: "Social",
  mini: "Mini",
  search_package: "Search package",
  select: "Select",
  validity: "Validity",
  electricity: "Electricity",
  gas: "Gas",
  govt_fees: "Govt Fees",
  internet: "Internet",
  water: "Water",
  choose_bill_category: "Choose bill category",
  bill_organization_company: "Bill organization/company",
  eg_wapda: "e.g. WAPDA",
  type_scan_account_number: "Type or scan account number",
  enter_customer: "Enter customer",
  billing_organization: "Billing organization",
  consumer_num: "Consumer #",
  billing_month: "Billing month",
  bill_amount_after_due_date: "Bill amount after due date",
  select_voucher: "Select voucher",
  voucher: "Voucher",
  voucher_to: "Voucher to {name}",
  easyload_to_name: "{item} to {name}",
  bills: "Bills",
  mobile_packages: "Mobile packages",
  total_easyload: "Total easyload",
  total_commission: "Total commission",
  total_bills_paid: "Total bills paid",
  total_vouchers_bought: "Total vouchers bought",
  all_transactions: "All transactions",
  nonIdealPendingCollectionSubtitle:
    "Easily collect money from friends and contacts right here. Once you send a request, it will appear in this list.",
  account_not_found_please_enter_valid_account_number_or_IBAN:
    "Account not found, please enter valid account number or IBAN",
  copied: "Copied",
  package_not_found: "Package not found",
  no_data_found: "No data found!",
  view_transactions: "View transactions",
  amount_range: "Amount range",
  no_transactions_found: "No transactions found",
  balance_insufficient: "Balance insufficient",
  your_sales_your_expenses_your_profit_crystal_clear:
    "Your sales, your expenses, your profit. Crystal clear.",
  send_invoices_collect_payments_easy_free:
    "Send invoices. Collect payments. Easy & Free",
  know_who_owes_remind_automatically_get_paid_3x_faster:
    "Know who owes. Remind automatically. Get paid 3x faster.",
  keep_stock_updated_never_miss_a_sale_sell_smarter:
    "Keep stock updated. Never miss a sale. Sell smarter",
  let_get_you_started: "Let's get you started",
  verify_your_otp: "Verify your OTP",
  select_contact: "Select contact",
  choose_voucher_type: "Choose voucher type",
  sell_voucher: "Sell voucher",
  voucher_details: "Voucher details",
  no_transactions_yet: "No transactions yet",
  Youll_see_your_all:
    "You’ll see your all money in and money out transaction history here",
  quicksale: "Quick sale",
  quick_sale_report: "Quick sale report",
  create_quick_sale: "Create quick sale",
  sale_amount: "Sale amount",
  edit_quicksale: "Edit quick sale",
  quickSale_has_been_successfully_updated:
    "Quick Sale has been successfully updated",
  quickSale_has_been_successfully_recorded:
    "Quick Sale has been successfully recorded",
  are_you_sure_you_want_to_delete_this_sale:
    "Are you sure you want to delete this sale record?",
  discard_quick_sale_btn: "Yes, discard this quick sale",
  total_paid_sales: "Total paid sales",
  total_unpaid_sales: "Total unpaid sales",
  search_by_sale_id: "Search by sale #",
  sale_id: "Sale ID",
  delete_sale: "Delete sale",
  lost_in_your_quickSales: "Lost in Your Sales?",
  OTP_verification_required: "OTP verification required",
  You_cant_leave_otp_verify_message:
    "You can’t leave this page without verifying the OTP.",
  sale_date_time: "Sale date & time",
  select_company_or_customer: "Select company or customer",
  customer_company: "Company / Customer ",
  recieved_amount: "Received amount",
  recieved: "Received",
  transaction_will_be_added_to_sales_and_contact:
    "Transaction will be added to sales and contact.",
  upload_attachment: "Upload attachment",
  account_detailsbank_transfer:
    "Collect payments via QR or bank transfer. 100% free",
  view_qr: "View QR",
  one_click_sale_faster_transaction: "One-click sales, faster transactions",
  speed_up_sales_reduce_wait_times:
    "Speed up sales, reduce wait times, and serve more contacts. Perfect for quick, everyday sales.",
  add_quick_sale: "Add quick sale",
  add_money_in: "Add money in",
  add_money_out: "Add money out",
  cash_book: "Cash Book",
  export: "Export",
  mark_as_paid: "Mark as paid",
  receipt: "receipt",
  quick_expense: "Quick expense",
  add_quick_expense: "Add quick expense",
  lost_in_expenses_stay_organized: "Lost in Your Expenses? Stay Organized",
  record_expense_as_soon_as:
    "Record expense as soon as they happen to ensure nothing is forgotten.",
  record_new_quick_sale: "Record new quick sale",
  download_bill: "Download bill",
  collect: "Collect",
  category_pl_tracking: "Category (P&L tracking)",
  select_sales_category: "Select sales category",
  scan_or_share_QR_to_collect_payment: "Scan or share QR to collect payment",
  get_qr: "Get QR",
  add_line_item: "Add line item",
  make_payment_with_bank_transfer:
    "Make payments with bank transfer. 100% free.",
  paid_on: "Paid on",
  unit_price: "Unit price",
  start_creating_your_first_sale_invoice:
    "Start creating your first sale invoice with easy steps",
  memo: "Memo",
  add_memo_here: "Add memo here",
  back: "Back",
  remaining_amount: "Remaining amount",
  received_amount: "Received amount",
  PO_number: "PO number",
  select_a_contact: "Select a contact",
  bank_account_details: "Bank account details",
  secure_100_free: "100% secure. 100% free.",
  ref_no: "Ref no.",
  are_you_sure_you_want_to_delete_invoice:
    "Are you sure you want to delete this invoice?",
  are_you_sure_you_want_to_delete_transaction:
    "Are you sure you want to delete this transaction?",
  start_your_account_by_adding_contact:
    "Start your accounts by adding a contact",
  account_help_you_track:
    "Accounts help you track who owes you money and whom you need to pay.",
  do_you_want_to_delete_associated_invoice:
    "Do you want to delete invoices associated to this contact?",
  add_transaction: "Add transaction",
  track_the_matter_of_you_took_money_or_gave_money:
    "Track the balance of you gave money or you took money from this contact.",
  no_transactions_matching_those_filters:
    "No transactions matching those filters",
  try_adjusting_filters: "Try adjusting filters or",
  reset_small: "reset",
  you_wont_be_able_to_change_it_later: "You won’t be able to change it later.",
  account_settled: "Account settled",
  payment_received: "Payment received",
  create_purchase_order: "Create purchase order",
  purchase_order: "Purchase order",
  start_creating_your_fist_purchase_order_with_easy_steps: "Start creating your first purchase order with easy steps",
  download_po: "Download PO",
  PO_no: "PO no",
  edit_purchase_order: "Edit purchase order",
  add_notes_here: "Add notes here",
  reference_number: "reference number",
  search_by_reference_number: "Search by reference number",
  accept_payments_into_your_bank_account: "Accept payments into your bank account",
  add_signature_on_invoice: "Add signature on invoice",
  get_your_bank_details: "Get your bank details",
  overdue: "Overdue",
  outstanding: "Outstanding",
  type_signature: "Type signature",
  activate_wallet: "Activate wallet",
  wholesale: "Wholesale",
  batchAndExpiry: "Batch & expiry",
  no_customers_yet: "No customers yet",
  you_have_not_added_any_customer: "You haven’t added any customers. Add customers to track money you will receive.",
  no_suppliers_yet: "No suppliers yet",
  add_suppliers_to_track_payments: "Add suppliers to track payments you need to make.",
  no_transactions_for_others_yet: "No transactions from others yet",
  when_someone_record_a_transaction_using_your_contact_details: "When someone records a transaction using your contact details, it will appear here automatically.",
  items_imported: "Items imported",
  create_search_term_as_new_contact: "Create '{name}' as new contact",
  inventory_management: "Inventory management",
  create_items_in_easy_steps_and_manage_inventory: "Create item in easy steps and manage inventory.",
  sell_price: "Sell price",
  current_qty: "Current qty",
  stock_in_qty: "Stock in qty",
  stock_out_qty: "Stock out qty",
  units_sold: "Units sold",
  total_cost: "Total cost",
  see_more: "See more",
  no_stock_history_yet: "No stock history yet",
  stock_changes_will_appear_here_one_you_start_adding: "Stock changes will appear here once you start adding or updating items.",
  transaction_added_by_this_contact_will_appear_here_automatically: "Transactions added by this contact will appear here automatically.",
  quick_sale: "Quick sale",
  all_your_sales_in_one_place: "All your sales in one place",
  manage_all_your_quick_sale_invoices_and_pos_transactions: "Manage all your Quick Sales, Invoices, and POS transactions together in one unified list.",
  businessoverview: "Business overview",
  add_expense: "add expense",
  Add_salesexpenses_to_see_your_PL_and_grow_your_profits: "Add sales & expenses to see your P&L and grow your profits.",
  viewPAndL: "view p&l",
  add_stock: "Add stock",
  sale_has_been_successfully_updated: "Sale has been successfully updated.",
  profit_Loss: "Profit & Loss",
  cash_flow: "Cash flow",
  total_cost_value: "Total cost value",
  cash_Bank: "Cash & Bank",
  total_item_in_stock: "Total items in stock",
  receivables: "Receivables",
  payables: "Payables",
  see_details: "See details",
  too_many_walk_ins_keep_them_smooth_with_pos: "Too many walk-ins? Keep them smooth with POS",
  start_pos: "start pos",
  cost_of_sales: "Cost of sales",
  gross_profit: "Gross profit",
  categories: "Categories",
  see_less: "See less",
  recent_transactions: "Recent transactions",
  gross_cash_inflow: "Gross cash inflow",
  gross_cash_outflow: "Gross cash outflow",
  net_cash_change: "Net cash change",
  change_category: "Change category",
  sales_category: "Sales category",
  category_updated: "Category updated",
  organize_your_expenses: "Organize your expenses",
  organize_your_sales: "Organize your sales",
  manage_your_Saddar_store_inventory_and_look_after_the_payments: "Manage your Saddar store inventory and look after the payments.",
  contact_attached_successfully: "Contact attached successfully",
  debit: "Debit",
  no_ledger_matching_those_filters: "No ledger matching those filters",
  clear_all_items: "Clear all items",
  add_to_sale: "Add to sale",
  search_by_customer_name_or_sale_id: "Search by customer name or order no",
  order_number: "Order number",
  Variation: "Variation",
  create_item_in_easy_steps_and_manage_stock: "Create item in easy steps and manage stock.",
  mark_in_stock: "Mark in stock",
  mark_out_of_stock: "Mark out of stock",
  change_language: "Change language",
  select_language: "Select your preferred language",
  change_appearance: "Change appearance",
  select_theme: "Select theme",
  light_mode: "Light mode",
  dark_mode: "Dark mode",
  delete_business: "Delete business",
  edit_profile: "Edit profile",
  create_business: "Create Business",
  confirmation: "Confirmation",
  no_order_matching_those_filters: "No order matching those filters",
  pin: "Pin",
  create_your_new_pin: "Create new PIN",
  confirm_your_new_pin: "Confirm PIN",
  enter_current_pin: "Enter current PIN",
  please_enter_your_4_digits_PIN_to_contine: "Please enter your 4 digits PIN to contine",
  your_accounts_first_line_of_defence_make_sure_its_unique: "Your account’s first line of defence. Make sure it’s unique and hard to guess.",
  pin_updated_successfully: "PIN updated successfully",
  profile_updated: "Profile updated",
  business_created: "Business created",
  variant_image: "Variant image",
  view: "View",
  setup_your_printer: "Setup your printer",
  download_applications: "Download applications",
  printer_selection: "Printer selection",
  test_printer: "Test printer",
  to_setup_printer_download_java: "To setup printer, download & install Java",
  download_java: "Download Java",
  watch_video_for_help: "Watch video for help",
  need_help_contact: "Need help? +92 341 1141000",
  test_selected_printer: "Test selected printer",
  printer_setup_successfully: "Printer setup successfully",
  proceed: "Proceed",
  select_printer: "Select printer",
  printers: "Printers",
  add_another_printer: "Add another printer",
  printer_name: "Printer name",
  connected: "Connected",
  not_connected: "Not connected",
  connect: "Connect",
  disconnect: "Disconnect",
  is_java_application_successfully_installed: "Is Java application successfully installed?",
  is_printer_software_successfully_installed: "Is printer software successfully installed?",
  is_printer_software_drivers_successfully_installed: "Is printer software drivers successfully installed?",
  is_printer_test_successful: "Is printer test successful?",
  please_select_a_printer: "Please select a printer",
  failed_to_connect_printer_please_try_again: "Failed to connect printer. Please try again.",
  download_and_install_printer_software: "Download & install printer software",
  download_and_install_drivers: "Download & install drivers",
  download_software: "Download Software",
  download_drivers: "Download Drivers",
  test_print: "Test Print",
  need_help: "Need help?",
  chat_with_us: "Chat with us",
  upload: "Upload",
  your_data_backup_is_up_to_date: "Your data backup is up to date",
  your_data_backup_is_not_up_to_date: "Your data backup is not up to date",
  error: "Error",
  enter_your_business_details: "Enter business details",
  stock_quantity: "Stock quantity",
  enter_your_business_name: "Enter your business name",
  create_and_send_invoices: "Create and send invoices",
  create_send_and_track_invoices_Get_paid_faster: "Create, send and track invoices. Get paid faster.",
  manage_your_accounts: "Manage your accounts",
  track_money_in_and_out_Faster_collections_100reliable: "Track money in and out. Faster collections. 100% reliable.",
  collect_send_and_earn_money: "Collect, send, and earn money",
  your_trusted_wallet_100_secure_completely_free: "Your trusted wallet. 100% secure. Completely free.",
  skip: "Skip",
  what_would_you_like_to_start: "How would you like to start?",
  scan_download_app: "Scan & Download App",
  select_unit_type: "Select unit type",
  sr_no: "Sr no.",
  backup_your_data: "Backup your data",
  no_option: "No option",
  is_your_printer_not_in_the_list: "Is your printer not present in the list? Install Java, the printer software, and the printer driver, then click on",
  loss: "Loss",
  net_loss: "Net loss",
  uncategorized: "Uncategorized",
  no_uncategorized_transactions: "No uncategorized transaction",
  all_sales_and_expenses_are_categorized: "All expense and sales are categorized. Great job keeping things organized!",
  create_an_account: "Create an account",
  login_to_rupin: "Login to RUPIN",
  log_in: "Log in",
  welcome_to: "Welcome to",
  change_phone_number: "Change phone number",
  send_code: "send code",
  verify_captcha: "Verify captcha",
  advance_paid: "Advance paid",
  you_are_currently_offline: "You’re currently offline",
  please_check_your_internet_connection_and_try_again: "Please check your internet connection and try again.",
  too_many_incorrect_attempts: "Too many incorrect PIN attempts",
  pin_entry_has_been_temporarily_locked_after_3_incorrect_attempts: "For your security, PIN entry has been temporarily locked after 3 incorrect attempts.",
  Youve_reached_the_8_transactions_limit: "You’ve reached the 8 transactions limit. Verify your phone number to continue using RUPIN securely.",
  You_reached_your_limit: "You’ve reached your limit",
  payment_received_added: "Payment received added",
  unified_view_of_quick_sale_invoice_and_pos: "Unified view of quick sale, invoice, and POS",
  account_locked: "Account locked",
  expense_category: "Expense category",
  select_expense_category: "Select expense category",
  select_due_date: "Select due date",
  start_typing_to_create_one: "Start typing to create one",
  select_purchase_category: "Select purchase category",
  add_signature_on_purchase_order: "Add signature on purchase order",
  purchase_no: "Purchase no",
  unsupported_file_format: "Unsupported file format",
  we_need_your_current_pin_to_proceed: "We need your current PIN to proceed.",
  net_cash: "Net cash",
  this_customer_entry_will_be_transferred_to_the_supplier_section: "This customer's entry will be transferred to the supplier section.",
  this_supplier_entry_will_be_transferred_to_the_customer_section: "This supplier's entry will be transferred to the customer section.",
  profits: "Profits",
  profit_Loss_statement: "Profit & Loss statement",
  account_temporarily_locked: "Account temporarily locked",
  invoice_created_with_rupin: "Invoice created with RUPIN",
  po_created_with_rupin: "PO created with RUPIN",
  go_to_listing: "Go to listing",
  invoice_details: "Invoice details",
  purchase_order_details: "Purchase order details",
  record_new_quick_expense: "Record new quick expense",
  account_temporarily_locked_OTP_desc: "For your security, this account has been temporarily locked after multiple incorrect OTP attempts.To regain access, please contact us",
  account_temporarily_locked_PIN_desc: "For your security, this account has been temporarily locked after multiple incorrect PIN attempts.To regain access, verify your identity using the Udhaar Book app.",
  order_saved_into_draft_sales: "Order saved into draft sales",
  add_contact_and_items_to_send_money: "Add contact and items to send money",
  amount_required_to_send_money: "Amount is required to send money",
  go_to_home: "Go to home",
  the_page_you_are_looking_for_may_be_moved_or_deleted: "The page you're looking for may have been moved or deleted.",
  item_image: "Item image",
  money: "Money",
  report_download_is_not_available_yet: "Report download is not available yet.",
  something_went_wrong: "Something went wrong",
  PIN_is_required: "PIN is required.",
  you_cannot_leave_this_page_without_creating_a_PIN: "You cannot leave this page without creating a PIN.",
  update_item_price: "Update item price",
  udhaar_book_is_now_rupin: "Udhaar Book is now Rupin.",
  migration_upgrade_subtitle: "We upgraded. Your account stays exactly the same.",
  migration_account_safe: "Your account is safe",
  migration_data_secure: "All data is secure",
  migration_transaction_intact: "Transaction history intact",
  migration_business_records_unchanged: "Business records unchanged",
  continue_to_rupin: "Continue to Rupin",
  rupin_migration_banner_message:
    "Udhaar Book is now Rupin. Everything safe, new features coming, all free.",
  no_vouchers: "No vouchers",
  no_bill_category: "No bill category",
  no_vouchers_available: "No vouchers available",
  there_are_no_vouchers_available_at_the_moment: "There are no vouchers available at the moment. Once vouchers become available, they will appear here.",
  are_you_sure_you_want_to_logout_all_data_will_be_lost: "Are you sure you want to log out? All data will be lost.",
  share_qr: "Share QR",
  show_qr: "Show QR",
  copy_qr_image: "Copy QR image",
  image_copied: "Image copied",
  view_statement: "View statement",
  incoming_this_month: "Incoming this month",
  outgoing_this_month: "Outgoing this month",
  account_limit: "Account limit",
  increase_limit: "Increase limit",
  total_limit: "Total limit",
  remaining: "Remaining",
  used: "Used",
  resets_on: "Resets on",
  upload_electricity_or_gas_bill_to_increase_limit: "Upload electricity or gas bill to increase limit",
  upload_bill: "Upload bill",
  ntn_number: "NTN number",
  enter_ntn_number: "Enter NTN number",
  ntn_number_length: "NTN number should be between 7 and 13 digits",
  something_went_wrong_please_try_again: "Something went wrong please try again",
  limit_increase_is_in_process: "Limit increase is in process",
  limit_increase_is_in_process_subtitle: "Thank you for submitting required details, we’ll contact you.",
  get_paid_faster: "Get paid faster",
  get_paid_faster_subtitle: "Start accepting payments with digital invoices",
  pay_bills: "Pay bills",
  enter_iban_account_raastid_name_or_phone: "Enter IBAN, Account #, Raast ID, Name or Phone #",
  select_start_bank: "Select the bank",
  no_banks_found: "No banks found",
  print_qr: "Print QR",
  download_qr: "Download QR",
  collect_payment_via_QR_or_bank_transfer: "Collect payment via QR or bank transfer. 100% free",
  limit_increase_request_in_process_need_help: "Limit increase request in process. Need help?  Chat with us",
  refund: "Refund",
  select_bill_category: "Select bill category",
  consumer_number: "Consumer number",
  scan_barcode: "Scan barcode",
  results: "Results",
  last_paid: "Last paid",
  select_bill: "Select bill",
  search_bill_by_name: "Search bill by name",
  no_bills_found: "No bills found",
  due: "Due",
  you_will_earn: "You will earn",
  points: "points",
  bill_paid_with: "Bill paid with",
  rupin: "RUPIN",
  bill_paid_with_rupin: "Bill paid with RUPIN",
  easyload_done_with: "Easyload done with",
  easyload_done_with_rupin: "Easyload done with RUPIN",
  voucher_sent_with: "Voucher sent with",
  voucher_sent_with_rupin: "Voucher sent with RUPIN",
  confirm_payment: "Confirm payment",
  failed_to_copy: "Failed to copy",
  money_sent_with: "Money sent with",
  money_sent_to: "Money sent to",
  money_sent_with_rupin: "Money sent with RUPIN",
  money_received: "Money received",
  money_sent: "Money sent",
  bundle_recharge: "Easyload package",
  mins: "mins",
  other_net_mins: "Other net mins",
  all_net_sms: "All net SMS",
  voucher_company: "Voucher company",
  select_voucher_company: "Select voucher company",
  search_voucher_by_name: "Search voucher by name",
  no_voucher_found: "No voucher found",
  recent: "Recent",
  no_results_enter_complete_account_or_iban: "No results, enter complete account no. or IBAN",
  top_up_account_to_complete_transaction: "Top up your account to complete this transaction.",
  search_bank: "Search bank",
  error_in_send_money: "Error in send money",
  transaction_failed: "Transaction failed",
  your_account_has_been_locked: "Your account has been locked",
  tid: "TID",
  by: "By",
  fee_free: "(Free)",
  fast_secure_payment_in: "Fast, secure payment in ",
  view_receipt: "View receipt",
  copy_receipt: "Copy receipt",
  network_type: "Network type",
  could_not_load_qr: "Could not load QR details. Please try again.",
  package_name: "Package name",
  bank_statement: "Bank statement",
  last_3_months: "Last 3 months",
  last_6_months: "Last 6 months",
  last_12_months: "Last 12 months",
  request_placed: "Request placed",
  downloading_statement: "Downloading statement...",
  duration: "Duration",
  easypaisa_tab: "Easypaisa",
  jazzcash_tab: "Jazzcash",
  searching: "Searching",
  weak_pin_choose_something_else: "Weak PIN. Choose something else",
  first_create_your_pin: "First create your PIN",
  others: "Others",
  add_first_transaction_for_name: "Add first transaction for {name}",
  invoice_sale: "Invoice sale",
  attachment: "Attachment",
  paid_transactions_cannot_be_edited: "Paid transactions cannot be edited.",
  enter_product_name: "Enter product name",
  enter_stock: "Enter stock",
  enter_low_stock: "Enter low stock",
  enter_sell_price: "Enter sell price",
  enter_barcode: "Enter barcode",
  enter_wholesale_price: "Enter wholesale price",
  enter_value: "Enter value",
  quick_item_save: "Save",
  quick_item_cancel: "Cancel",
  bulk_upload_invalid_item_name: "Invalid item name. Use letters, numbers, spaces, - or _ only.",
  bulk_upload_item_name_missing: "Item name is not filled in the CSV template.",
  custom_date_range: "Custom date range",
  custom_statements: "Custom statements",
  statement_generation_started: "Your statement is being generated. You can find it in View statements.",
  no_available_statements: "No available statements",
  no_available_statements_subtitle: "Your  bank statements will appear here once available",
  in_progress: "In process",
  cashback_on_easyload: "Cashback on easyload",
  you_dont_have_any_pending_collections: "You don't have any pending collections",
  are_you_sure_you_want_to_delete_statement: "Are you sure you want to delete statement",
  channel: "Channel",
  avg_order_value: "Avg. Order value",
  contribution: "Contribution",
  total_collected: "Total collected",
  percentage: "Percentage",
  items_sold: "Items sold",
  gross_sales: "Gross sales",
  net_sales: "Net sales",
  last_sold: "Last sold",
  current_stock: "Current stock",
  cost: "Cost",
  profit_margin: "Profit margin",
  average_unit_price: "Average unit price",
  average_expense: "Average expense",
  last_purchased: "Last purchased",
  cost_of_stock_sold: "Cost of stock sold",
  gross_loss: "Gross loss",
  total_discount: "Total discount",
  orders_with_discount: "Orders with discount",
  average_discount_per_order: "Average discount per order",
  total_tax_collected: "Total tax collected",
  taxable_sales: "Taxable sales",
  tax_free_sales: "Tax free sales",
  multiple_tax_rates: "Multiple tax rates",
  tax_rate: "Tax rate",
  tax_collected: "Tax collected",
  activate_account: "Activate account",
  activate_now: "Activate now",
  add_money_from_any_bank_free: "Add money from any bank. 100 Free.",
  add_money_from_easypaisa: "Add money from Easypaisa",
  easypaisa_step_see_all: "Click on 'See all'",
  easypaisa_step_fee_collection: "Select 'Fee collection'",
  easypaisa_step_search_rupin: "Search and select 'Rupin'",
  easypaisa_step_enter_consumer_id: "Enter consumer ID",
  instruction_for_adding_money: "Instructions for adding money",
  getQR: "Get QR",
  enter_amount: "Enter amount",
  processing_limit_increase_contact_you: "Processing limit increase. We’ll contact you",
  track_every_rupee: "Track every rupee",
  record_daily_cash_in_and_cash_out: "Record daily cash in and cash out.",
  add_category_to_track_PAndL: "add category to track P&L",
  saved_successfully: "Saved successfully",
  unable_to_load_this_entry: "Unable to load this entry",
  instruction_for_adding_money : "Instructions for adding money",
  getQR : "Get QR",
  enter_amount : "Enter amount",
  processing_limit_increase_contact_you: "Processing limit increase. We’ll contact you",
  view_yearly_data: "view yearly data",
  no_data_yet : "No data yet",
  it_looks_like_you_dont_have_any_data_yet: "It looks like you haven't made any transactions yet.",
  start_new_sale: "Start new sale",
  sales_summary : "Sales summary",
  discount_summary : "Discount summary",
  expense_by_category : "Expense by category",
  low_selling_items : "Low selling items",
  sales_by_category : "Sales by category",
  sales_by_payment_method : "Sales by payment method",
  tax_summary : "Tax summary",
  top_contacts_by_sale : "Top contacts by sale",
  total_sales_by_channel : "Total sales by channel",
  incorrect_reference_number: "Incorrect reference number",
  bill_image_will_appear_here: "Bill image will appear here",
  reference_no: "Reference no.",
  account_no: "Account no.",
  customer_id: "Customer ID",
  instantly_check_your_bill: "Instantly check your bill",
  enter_bill_details_below: "Enter bill details below to view and pay your bill",
  search_bill: "Search bill",
  powered_by_nadra: "Powered by Nadra",
  trusted_by_5_3_million_users: "Trusted by 5.3 million+ users",
  select_biller: "Select biller",
  your: "Your",
  check_pay_bills_with_rupin: "Check & pay bills with Rupin",
  visibility: "Visibility",
  published: "Published",
  by_others: "By others",
  method: "Method",
  newest: "Newest",
  oldest: "Oldest",
  amount_high_to_low: "Amount (High to Low)",
  amount_low_to_high: "Amount (Low to High)",
  search: "Search",
  name_z_a: "Name (Z-A)",
  quantity_high_to_low: "Quantity (High to Low)",
  quantity_low_to_high: "Quantity (Low to High)",
  end: "End",
  keyword: "Keyword",
  seller_central: "Seller central",
  pincode_menu_label: "Pincode",
  printer: "Printer",
  search_by: "Search by",
  something_went_wrong_fetching_transactions: "Something went wrong while fetching transactions",
  download_url_not_available: "Download URL is not available",
  pdf_downloaded_successfully: "PDF downloaded successfully",
  failed_to_download_file: "Failed to download file",
  sent: "Sent",
  transfer: "Transfer",
  withdraw: "Withdraw",
  bill_payment_text: "Bill payment",
  voucher_payment_text: "Voucher Payment",
  rupin_cashback: "Rupin Cashback",
  sms_plan: "SMS plan",
  order_hash: "Order #",
  please_add_a_phone_number_to_continue: "Please add a phone number to continue",
  bill_fetching_failed: "Bill fetching failed",
  error_fetching_bill_transaction: "Error fetching bill transaction",
  not_paid_overdue: "Not paid (Overdue)",
  month: "Month",
  consumer_id: "Consumer ID",
  bills_will_appear_here_once_available: "Bills will appear here once available",
  bill_not_found: "Bill not found",
  error_fetching_bill: "Error fetching bill",
  bill_payment_failed: "Bill payment failed",
  error_in_bill_payment: "Error in Bill Payment",
  please_add_phone_number_to_continue: "Please add a phone number to continue",
  search_by_name_or_phone: "Search by name or phone",
  no_of_transactions: "No. of transactions",
  try_adjusting_your_filters_or: "Try adjusting your filters or ",
  transactions_will_appear_here_once_available: "Transactions will appear here once available",
  cashback: "Cashback",
  error_in_recharge: "Error in recharge",
  free: "Free",
  on_net_mins: "On net Mins",
  gbs_data: "GBs data",
  all_in_one_weekly: "All-in-One Weekly",
  error_in_easyload_and_package: "Error in EasyLoad & Package",
  default_processing_time: "2.6 sec",
  open_your_bank_app_easypaisa_or_jazzcash: "Open your Bank app, Easypaisa or Jazzcash",
  tap_send_or_transfer: "Tap ‘Send’ or ‘Transfer’",
  search_rupin: "Search Rupin",
  enter_rupins_account_number_or_iban: "Enter Rupin’s account number or IBAN",
  easypaisa_app_send_money: "Easypaisa app (Send money)",
  open_easypaisa_app: "Open Easypaisa app",
  tap_on_send_money: "Tap on ‘Send money’",
  select_bank_transfer: "Select ‘Bank transfer’",
  select_bank_rupin: "Select bank ‘Rupin’",
  easypaisa_app_collection: "Easypaisa app (Collection)",
  tap_on_see_all: "Tap on ‘See all’",
  tap_on_fee_collection: "Tap on ‘Fee collection’",
  search_and_select_udhaar_app: "Search and select \"Udhaar App\"",
  enter_consumer_id: "Enter consumer ID",
  open_jazzcash_app: "Open Jazzcash app",
  tap_on_money_transfer: "Tap on ‘Money transfer’",
  tap_on_bank_transfer: "Tap on ‘Bank transfer’",
  cash_bank: "Cash/Bank",
  voucher_purchase_failed: "Voucher purchase failed",
  error_in_buy_voucher: "Error in buy Voucher",
  voucher_transaction_failed: "Voucher transaction failed",
  error_fetching_voucher_transaction: "Error fetching voucher transaction",
  to_lowercase: "to",
  cashback_label: "Cashback",
  bill_payment_label: "Bill payment",
  consumer_name: "Consumer name",
  consumer_name_caps: "Consumer Name",
  no_of_bills: "No. of bills",
  try_adjusting_your_filters: "Try adjusting your filters or ",
  attach_label: "Attach",
  to_this_transaction_confirm: "to this transaction?",
  attach_contact_confirm: "Attach {name} to this transaction?",
  contact_linked_successfully: "Contact linked successfully",
  failed_to_link_contact: "Failed to link contact",
  transaction_not_available: "Transaction not available",
  error_fetching_transaction: "Error fetching transaction",
  account_locked_contact_support: "Your account has been locked please contact support",
  previous_slide: "Previous slide",
  next_slide: "Next slide",
  wallet_onboarding_b_slide3_alt: "Rupin QR receive",
  wallet_onboarding_b_slide2_alt: "Supported banks",
  wallet_onboarding_b_slide1_alt: "Rupin wallet",

  minimum_amount: "Minimum amount",
  maximum_amount: "Maximum amount",
  search_by_contact: "Search by contact",
  search_by_contact_or_order_no: "Search by contact or order no",
  search_by_contact_or_invoice_no: "Search by contact or invoice no",
  invalid_number: "Invalid number",
  cannot_be_negative: "Cannot be negative",
  cannot_be_negative_or_zero: "Cannot be negative or zero",
  max_should_be_greater_than_min: "Max should be greater than Min",
  thirty_days: "30 Days",
  half_yearly: "6 Months",

  fill_in_your_data: "Fill in your data",
  upload_the_file: "Upload the file",
  csv_xls_files_supported: "(.csv and .xls files are supported)",
  invalid_file_format_csv_xls: "Invalid file format. Please upload a .csv, .xls, or .xlsx file.",
  file_uploaded: "File uploaded",
  finished: "Finished",
  entries_imported_successfully: "entries imported successfully.",
  entries_failed: "entries failed",
  item_discount: "Item discount",
  remove_item: "Remove item",
  transaction_details: "Transaction details",

  scan_and_pay: "Scan and pay",
  scan_qr: "Scan QR",
  bank_transfer: "Bank transfer",
  transfer_to_this_iban: "Transfer to this IBAN",
  transfer_exact_amount_shown_above: "Transfer the exact amount shown above",
  how_to_pay: "How to pay",
  scan_step_1: "Open your banking app or wallet and scan the QR code above.",
  scan_step_2: "Confirm the amount, Rs. {amount} and transfer",
  scan_step_3: "Click Pay.",
  bank_step_1: "Open your banking app or wallet",
  bank_step_2: "Transfer the exact amount Rs. {amount} to the IBAN above",
  bank_step_3: "Click Pay.",
  payment_confirmation_sms_note: "You will receive a payment confirmation and Transaction ID on your SMS",
  verify_payment: "Verify Payment",
  bill_payment_to: "Bill payment to",
  reports : "Reports",
  payment_mode : "Payment mode",
  contact_support : "Contact support",
};

